if (document.getElementById('web-on-boarding-test')) {
    window.webOnBoarding = {
        commonQuestions: [
            {
                question: 'Is this allergy review for you or your child?',
                multipleOptions: [
                    {
                        title: 'Me',
                    },
                    {
                        title: 'My child',
                    }
                ]
            },
            {
                question: 'What would you like to know about allergies? ',
                selectApplicable: true,
                multipleOptions: [
                    {
                        title: 'Find out more about allergies in general',
                    },
                    {
                        title: 'Whether my symptoms might be linked to an allergy',
                    },
                    {
                        title: 'What allergy treatments are available',
                    },
                    {
                        title: "How to prepare for a doctor's appointment",
                    },
                    {
                        title: 'How to manage allergies day to day',
                    },
                    {
                        title: 'Something else',
                        disable: true,
                    }
                ]
            },
            {
                question: 'Has a doctor diagnosed you with an allergy?',
                multipleOptions: [
                    {
                        title: 'Yes',
                    },
                    {
                        title: 'No',
                    }
                ]
            }
        ],
        diagnosedQuestions: [
            {
                question: 'Which allergies have you been diagnosed with? ',
                category: '',
                questionType: 3,
                selectApplicable: true,
                subMultipleOptionsCategory: 'Pollen',
                subMultipleOptions: [
                    {
                        title: 'Grass Pollen'
                    },
                    {
                        title: 'Tree Pollen'
                    },
                    {
                        title: 'Weed Pollen'
                    }
                ],
                subMultipleOptionsCategory2: '',
                subMultipleOptions2: [],
                multipleOptions: [
                    {
                        title: 'Dust mite',
                    },
                    {
                        title: 'Animals',
                    },
                    {
                        title: 'Certain foods',
                    },
                    {
                        title: 'Insect stings',
                    },
                    {
                        title: 'Other',
                        disable: true,
                    }
                ],
                logoImage: '',
            },
            // {
            //     question: 'How are your eyes affected?',
            //     category: 'Eyes',
            //     questionType: 2,
            //     subMultipleOptionsCategory: '',
            //     subMultipleOptions: [],
            //     subMultipleOptionsCategory2: '',
            //     subMultipleOptions2: [],
            //     multipleOptions: [
            //         {
            //             title: 'Itchy',
            //         },
            //         {
            //             title: 'Watery',
            //         },
            //         {
            //             title: 'Red',
            //         }
            //     ],
            //     logoImage: 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_Test_step_1_eye_top_icon_blue.svg'
            // },
            // {
            //     question: 'How is your nose affected?',
            //     category: 'Nose',
            //     questionType: 2,
            //     subMultipleOptionsCategory: '',
            //     subMultipleOptions: [],
            //     subMultipleOptionsCategory2: '',
            //     subMultipleOptions2: [],
            //     multipleOptions: [
            //         {
            //             title: 'Stuffy',
            //         },
            //         {
            //             title: 'Runny',
            //         },
            //         {
            //             title: 'Sneezing',
            //         },
            //         {
            //             title: 'Itchy',
            //         }
            //     ],
            //     logoImage: 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_Test_step_2_nose_top_icon_blue.svg'
            // },
            // {
            //     question: 'How are your sleep and energy levels affected?',
            //     category: 'Tiredness',
            //     questionType: 2,
            //     subMultipleOptionsCategory: '',
            //     subMultipleOptions: [],
            //     subMultipleOptionsCategory2: '',
            //     subMultipleOptions2: [],
            //     multipleOptions: [],
            //     logoImage: 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_Test_step_4_tiredness_top_icon_blue.svg'
            // },
            // {
            //     question: 'Do you have any of these breathing issues?',
            //     category: '',
            //     questionType: 1,
            //     subMultipleOptionsCategory: '',
            //     subMultipleOptions: [],
            //     subMultipleOptionsCategory2: '',
            //     subMultipleOptions2: [],
            //     multipleOptions: [
            //         {
            //             title: 'Coughing',
            //         },
            //         {
            //             title: 'Tight chest',
            //         },
            //         {
            //             title: 'Wheezing',
            //         },
            //         {
            //             title: 'None',
            //             disable: true,
            //         }
            //     ],
            //     logoImage: ''
            // },
            {
                question: 'Do you feel your symptoms are under control?',
                category: '',
                questionType: 1,
                subMultipleOptionsCategory: '',
                subMultipleOptions: [],
                subMultipleOptionsCategory2: '',
                subMultipleOptions2: [],
                multipleOptions: [
                    {
                        title: 'Yes',
                    },
                    {
                        title: 'No',
                    }
                ],
                logoImage: ''
            },
            {
                question: 'Which allergy treatments are you familiar with? ',
                category: '',
                questionType: 4,
                selectApplicable: true,
                subMultipleOptionsCategory: 'Medicines that relieve symptoms, such as antihistamines or corticosteroids',
                subMultipleOptions: [
                    {
                        title: 'Tablets or capsules'
                    },
                    {
                        title: 'Syrups'
                    },
                    {
                        title: 'Nasal sprays'
                    },
                    {
                        title: 'Eye drops'
                    },
                    {
                        title: 'Inhalers'
                    },
                    {
                        title: 'Creams or lotions'
                    }
                ],
                subMultipleOptionsCategory2: 'Allergy immunotherapy',
                subMultipleOptions2: [
                    {
                        title: 'Tablets',
                    },
                    {
                        title: 'Injections',
                    },
                    {
                        title: 'Other',
                        disable: true,
                    }
                ],
                logoImage: ''
            },
            {
                question: 'Last one! How do your symptoms affect your day-to-day life? ',
                category: '',
                questionType: 1,
                selectApplicable: true,
                subMultipleOptionsCategory: '',
                subMultipleOptions: [],
                subMultipleOptionsCategory2: '',
                subMultipleOptions2: [],
                multipleOptions: [
                    {
                        title: 'I avoid some activities',
                    },
                    {
                        title: 'Poor sleep',
                    },
                    {
                        title: 'Family routines are disrupted',
                    },
                    {
                        title: 'Difficulty concentrating at school or work',
                    },
                    {
                        title: 'Missing out on sport or exercise',
                    },
                    {
                        title: 'Other',
                        disable: true,
                    },
                    {
                        title: 'No impact',
                        disable: true,
                    }
                ],
                logoImage: ''
            }
        ],
        unDiagnosedQuestions: [
            {
                question: 'How are your eyes affected? ',
                category: 'Eyes',
                questionType: 2,
                subMultipleOptionsCategory: '',
                subMultipleOptions: [],
                subMultipleOptionsCategory2: '',
                subMultipleOptions2: [],
                multipleOptions: [
                    {
                        title: 'Itchy',
                    },
                    {
                        title: 'Watery',
                    },
                    {
                        title: 'Red',
                    }
                ],
                logoImage: 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_Test_step_1_eye_top_icon_blue.svg'
            },
            {
                question: 'Which nasal symptoms do you experience? ',
                category: 'Nose',
                questionType: 2,
                subMultipleOptionsCategory: '',
                subMultipleOptions: [],
                subMultipleOptionsCategory2: '',
                subMultipleOptions2: [],
                multipleOptions: [
                    {
                        title: 'Blocked',
                    },
                    {
                        title: 'Runny',
                    },
                    {
                        title: 'Itchy',
                    },
                    {
                        title: 'Sneezing',
                    }
                ],
                logoImage: 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_Test_step_2_nose_top_icon_blue.svg'
            },
            {
                question: 'How is your breathing affected? ',
                category: 'Breathing',
                questionType: 2,
                subMultipleOptionsCategory: '',
                subMultipleOptions: [],
                subMultipleOptionsCategory2: '',
                subMultipleOptions2: [],
                multipleOptions: [
                    {
                        title: 'Coughing',
                    },
                    {
                        title: 'Tight chest',
                    },
                    {
                        title: 'Wheezing',
                    }
                ],
                logoImage: 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_Test_step_3_lungs_top_icon_blue.svg'
            },
            {
                question: 'How are your sleep and energy levels affected?',
                category: 'Sleep',
                questionType: 2,
                subMultipleOptionsCategory: '',
                subMultipleOptions: [],
                subMultipleOptionsCategory2: '',
                subMultipleOptions2: [],
                multipleOptions: [],
                logoImage: 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_Test_step_4_tiredness_top_icon_blue.svg'
            },
            // {
            //     question: 'Do you have any of these breathing issues?',
            //     category: '',
            //     questionType: 1,
            //     subMultipleOptionsCategory: '',
            //     subMultipleOptions: [],
            //     subMultipleOptionsCategory2: '',
            //     subMultipleOptions2: [],
            //     multipleOptions: [
            //         {
            //             title: 'Coughing',
            //         },
            //         {
            //             title: 'Tight chest',
            //         },
            //         {
            //             title: 'Wheezing',
            //         },
            //         {
            //             title: 'None',
            //             disable: true,
            //         }
            //     ],
            //     logoImage: ''
            // },
            {
                question: 'When and where are your symptoms at their worst?',
                category: '',
                questionType: 1,
                selectApplicable: true,
                subMultipleOptionsCategory: '',
                subMultipleOptions: [],
                subMultipleOptionsCategory2: '',
                subMultipleOptions2: [],
                multipleOptions: [
                    {
                        title: 'Spring',
                        attribute: 'season',
                    },
                    {
                        title: 'Summer',
                        attribute: 'season',
                    },
                    {
                        title: 'Autumn',
                        attribute: 'season',
                    },
                    {
                        title: 'Winter',
                        attribute: 'season',
                    },
                    {
                        title: 'All year round',
                        attribute: 'all season',
                    },
                    {
                        title: 'Indoors',
                        attribute: '',
                    },
                    {
                        title: 'Outdoors',
                        attribute: '',
                    },
                    {
                        title: 'I don’t know',
                        disable: true,
                        attribute: '',
                    }
                ],
                logoImage: ''
            },
            {
                question: 'What do you think might trigger your symptoms?',
                category: '',
                questionType: 3,
                selectApplicable: true,
                subMultipleOptionsCategory: 'Pollen',
                subMultipleOptions: [
                    {
                        title: 'Grass Pollen'
                    },
                    {
                        title: 'Tree Pollen'
                    },
                    {
                        title: 'Weed Pollen'
                    }
                ],
                subMultipleOptionsCategory2: '',
                subMultipleOptions2: [],
                multipleOptions: [
                    {
                        title: 'Dust mite',
                    },
                    {
                        title: 'Animals',
                    },
                    {
                        title: 'Certain foods',
                    },
                    {
                        title: 'Insect stings',
                    },
                    {
                        title: 'Other/I Don’t know',
                        disable: true,
                    }
                ],
                logoImage: ''
            },
            {
                question: 'Last one! Does anyone in your family have hay fever, asthma, food allergies, hives or other skin rashes?',
                category: '',
                questionType: 1,
                subMultipleOptionsCategory: '',
                subMultipleOptions: [],
                subMultipleOptionsCategory2: '',
                subMultipleOptions2: [],
                multipleOptions: [
                    {
                        title: 'Yes',
                    },
                    {
                        title: 'I don’t know',
                    },
                    {
                        title: 'No',
                    },
                    {
                        title: 'Prefer not to say',
                    }
                ],
                logoImage: ''
            }
            // {
            //     question: 'Have you ever had these conditions?',
            //     category: '',
            //     questionType: 1,
            //     subMultipleOptionsCategory: '',
            //     subMultipleOptions: [],
            //     subMultipleOptionsCategory2: '',
            //     subMultipleOptions2: [],
            //     multipleOptions: [
            //         {
            //             title: 'Eczema',
            //         },
            //         {
            //             title: 'Asthma',
            //         },
            //         {
            //             title: 'None',
            //             disable: true,
            //         }
            //     ],
            //     logoImage: ''
            // }
        ],
        answers: [
            {
                question: '',
                options: [],
                subQuestion: '',
                subOptions: [],
                subQuestion2: '',
                subOptions2: [],
                category: '',
                vas_score: null
            },
            {
                question: '',
                options: [],
                subQuestion: '',
                subOptions: [],
                subQuestion2: '',
                subOptions2: [],
                category: '',
                vas_score: null
            },
            {
                question: '',
                options: [],
                subQuestion: '',
                subOptions: [],
                subQuestion2: '',
                subOptions2: [],
                category: '',
                vas_score: null
            },
            {
                question: '',
                options: [],
                subQuestion: '',
                subOptions: [],
                subQuestion2: '',
                subOptions2: [],
                category: '',
                vas_score: null
            },
            {
                question: '',
                options: [],
                subQuestion: '',
                subOptions: [],
                subQuestion2: '',
                subOptions2: [],
                category: '',
                vas_score: null
            },
            {
                question: '',
                options: [],
                subQuestion: '',
                subOptions: [],
                subQuestion2: '',
                subOptions2: [],
                category: '',
                vas_score: null
            },
            {
                question: '',
                options: [],
                subQuestion: '',
                subOptions: [],
                subQuestion2: '',
                subOptions2: [],
                category: '',
                vas_score: null
            },
            {
                question: '',
                options: [],
                subQuestion: '',
                subOptions: [],
                subQuestion2: '',
                subOptions2: [],
                category: '',
                vas_score: null
            },
            {
                question: '',
                options: [],
                subQuestion: '',
                subOptions: [],
                subQuestion2: '',
                subOptions2: [],
                category: '',
                vas_score: null
            },
            {
                question: '',
                options: [],
                subQuestion: '',
                subOptions: [],
                subQuestion2: '',
                subOptions2: [],
                category: '',
                vas_score: null
            },
            {
                question: '',
                options: [],
                subQuestion: '',
                subOptions: [],
                subQuestion2: '',
                subOptions2: [],
                category: '',
                vas_score: null
            }
        ],
        indicatorImages: [
            'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_blue_blob_test.svg',
            'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_green_blob_test.svg',
            'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_orange_blob_test.svg',
            'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_red_blob_test.svg',
        ],
        highestVASScore: 0,
        typeOfQuestion: '',
        typeOfQuiz: '',
        highestVASCategory: [],
        imageCharacter: 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_blue_blob_test.svg',
        highestVASColor: '#009DC1',
        currentQuestion: 1,
        nextQuestion: 2,
        previousQuestion: 0,
        currentStep: 'step-1',
        WOBQuizContainer: document.querySelector('[data-wob-quiz]'),
        // QACIntroSlider: document.querySelector('[data-qac-intro-slider]'),
        commonQuestionsContainer: document.querySelector('#common-questions'),
        diagnosedQuestionsContainer: document.querySelector('#diagnosed-questions'),
        unDiagnosedQuestionsContainer: document.querySelector('#unDiagnosed-questions'),
        isDiagnosedOrNot: true,
        indicatorPopUp: document.querySelector('.indicator-value-overlay'),
        introSlide: document.querySelector('.quiz-background-color .intro-slide'),
        questionSlide: document.querySelector('.quiz-background-color .question-slide'),
        signupForms: [document.querySelector('#wob-braze-form-main form'), document.querySelector('#wob-braze-form-popup-main form')],
        closeQuizPopup: document.querySelector('[data-close-quiz-popup]'),
        closeQuizResultPopup: document.querySelector('[data-close-quiz-result-popup]'),
        resultContainer: document.querySelector('#step-result'),
        tyDivContainer: document.querySelector('#thank-you-div'),
        quizContainer: document.querySelector('.quiz-background-color'),
        resultTitle: '',
        resultMessage: '',
        knownUser: false,
        newsletterSignupVal: 'off',
        wob_stage: '',

        init() {
            // console.log("Button for result", document.querySelector('.block-result .result-button-container button'));
            this.setHTML();

            if (this.getCookie('WOBID_Cookie') != '' && this.getCookie('WOBID_Cookie') != null && this.getCookie('WOBID_Cookie') != 'WOBID_Cookie') {
                this.knownUser = true;
                document.querySelectorAll('.braze-form-container.form .newsletter_signup_checkbox').forEach(newsletterSignupCheckbox => {
                    newsletterSignupCheckbox.classList.add('d-none');
                }); 
                // document.querySelector('.brazeFormContainer.result').classList.remove('d-none');
                // document.querySelector('.brazeFormContainer.signup').classList.add('d-none');
            }
            else {
                this.knownUser = false;
            }

            document.querySelector('#start-quiz').addEventListener('click', (e) => {
                this.introSlide.classList.add('d-none');

                this.questionSlide.classList.remove('d-none');
                window.dataLayer.push({
                    'event': 'wob_started'
                });

                document.querySelector('.web-on-boarding [data-question-collection=common] #step-1-questionContainer .answer-container [data-option-type=multiCheckboxes] [name="common-0"]').click();
            });
            // document.querySelector('#qac-start-quiz').addEventListener('click', (e) => {
            //     window.location.href = "https://allergiecheck.de/pages/allergie-schnellcheck";
            //     window.dataLayer.push({
            //         'event': 'web_wob_to_qac'
            //     });
            // });
            document.querySelectorAll('.scale-container .indicator-popup-text-container').forEach(indicatorpopupText => {
                indicatorpopupText.addEventListener('click', () => {
                    this.indicatorPopUp.classList.remove('d-none');
                })
            });
            this.indicatorPopUp.querySelector('.navigation-icon').addEventListener('click', () => {
                this.indicatorPopUp.classList.add('d-none');
            });

            document.querySelectorAll('[data-question-close]').forEach(questionClose => {
                questionClose.addEventListener('click', ()=>{
                    this.closeQuizPopup.classList.remove('d-none');
                });
            });

            document.querySelector('[data-intro-close]').addEventListener('click', () =>{
                this.closeQuizPopup.classList.remove('d-none');
            });
        
            document.querySelector('.quiz-question-popup .yes-btn').addEventListener('click', () =>{
                window.location.href = "/pages/online-allergy-test";
            });

            document.querySelector('.quiz-question-popup .close-navigation-btn').addEventListener('click', () =>{
                this.closeQuizPopup.classList.add('d-none');
            });

            document.querySelector('.quiz-question-popup .no-btn').addEventListener('click', () =>{
                this.closeQuizPopup.classList.add('d-none');
            });

            document.querySelector('.quiz-result-popup .yes-btn').addEventListener('click', (e) =>{
                let dataUrl = e.target.getAttribute('data-url');
                window.location.href = dataUrl;
            });

            document.querySelector('.braze-form-popup.quiz-popup-overlay .close-navigation-btn').addEventListener('click', ()=>{
                document.querySelector('.braze-form-popup.quiz-popup-overlay').classList.add('d-none');
            })

            document.querySelector('.quiz-result-popup .no-btn').addEventListener('click', () =>{
                // form popup active
            });

            document.querySelector('[data-result-close]').addEventListener('click', ()=>{
                this.closeQuizResultPopup.classList.remove('d-none');
            });

            document.querySelector('.quiz-result-popup .close-navigation-btn').addEventListener('click', () =>{
                this.closeQuizResultPopup.classList.add('d-none');
            });

            this.closeQuizResultPopup.querySelector('button.no-btn').addEventListener('click', ()=>{
                console.log("Opening the braze popup form",  document.querySelector('#wob-braze-form-popup-main'))
                document.querySelector('.braze-form-popup.quiz-popup-overlay').classList.remove('d-none');
                this.closeQuizResultPopup.classList.add('d-none');
            })

            // document.querySelectorAll('input[type="range"]').forEach(slider => {
            //     slider.addEventListener('change', (e) => {
            //         let parentElement = e.currentTarget.closest('.scale-container');
            //         let imageElement = parentElement.querySelector('img');
            //         if (e.currentTarget.value == 0) {

            //             imageElement.src = this.indicatorImages[0];
            //         }
            //         if (e.currentTarget.value == 1) {

            //             imageElement.src = this.indicatorImages[1];
            //         }
            //         if (e.currentTarget.value < 5 && e.currentTarget.value > 1) {
            //             imageElement.src = this.indicatorImages[2];
            //         }
            //         if (e.currentTarget.value > 4) {
            //             imageElement.src = this.indicatorImages[3];
            //         }
            //     })
            // });

            //to select only one option for question 1 and question 3
            document.querySelectorAll(`.question-answer#step-1-questionContainer [data-option-type="multiCheckboxes"] input[type="checkbox"], .question-answer#step-3-questionContainer input[type="checkbox"], 
            [data-question-collection="diagnosed"] .question-answer#step-9-questionContainer input[type="checkbox"], [data-question-collection="unDiagnosed"] 
            .question-answer#step-10-questionContainer input[type="checkbox"]`).forEach(input => {
                // console.log("input of single selection", input);
                let inputParent = input.closest('.dynamicQuestion');
                let inputParentParameter = inputParent.getAttribute('id');
                let inputParentParameterString = inputParentParameter.split("-");
                let inputParentID = inputParentParameterString[1];
                let inputs;
                if (inputParentID == 1) {
                    inputs = document.querySelectorAll(`.question-answer#step-1-questionContainer [data-option-type="multiCheckboxes"] input[type="checkbox"]`);
                }
                else if (inputParentID == 3) {
                    inputs = document.querySelectorAll(`.question-answer#step-3-questionContainer input[type="checkbox"]`);
                }
                else if (inputParentID == 9) {
                    inputs = document.querySelectorAll(`[data-question-collection="diagnosed"] .question-answer#step-9-questionContainer input[type="checkbox"]`);
                }
                else if (inputParentID == 10) {
                    inputs = document.querySelectorAll(`[data-question-collection="unDiagnosed"] .question-answer#step-10-questionContainer input[type="checkbox"]`);
                }
                input.addEventListener('change', (e) => {
                    if (input.checked) {
                        inputs.forEach(otherCheckbox => {
                            if (otherCheckbox !== input) {
                                otherCheckbox.checked = false;
                            }
                        });
                    }
                });
            });
            //change event for input of questions
            document.querySelectorAll('.main-answer-container input[type=checkbox]').forEach(checkbox => {
                checkbox.addEventListener('change', (e) => {
                    let currentQuestion = e.currentTarget.closest('.dynamicQuestion');
                    if (!currentQuestion.classList.contains('d-none')) {
                        let allCheckedChecboxes = currentQuestion.querySelectorAll('input[type="checkbox"]:checked');
                        let btn = currentQuestion.querySelector('.right-navigation-button-container');
                        if (allCheckedChecboxes.length > 0) {
                            btn.disabled = false;
                        }
                        else {
                            btn.disabled = true;
                        }
                    }
                })
            })
            //to close the QAC intro slide
            // document.querySelector('[data-qac-intro-slider] .navigation-container .left-navigation-button-container').addEventListener('click', () => {
            //     this.QACIntroSlider.classList.add('d-none');
            //     this.WOBQuizContainer.classList.remove('d-none');
            //     let stepElements = document.querySelectorAll('[data-wob-quiz] .description-container .pagination .step');
            //     for (let i = 0; i < stepElements.length; i++) {
            //         stepElements[i].classList.remove('completed');
            //         stepElements[i].classList.remove('active');
            //         if (i == 0) {
            //             stepElements[i].classList.add('active');
            //         }
            //     }
            // });

            //to navigate to next question for common question
            document.querySelectorAll('.dynamicQuestion .right-navigation-button-container').forEach(navigationBtnEl => {
                navigationBtnEl.addEventListener('click', (e) => {
                    let nextQuestion = navigationBtnEl.getAttribute('data-next-step');
                    let currentQuestion = navigationBtnEl.closest('.dynamicQuestion');
                    this.getAnswer(e);
                    //to open the QAC intro slide
                    var consent = document.querySelector('input[name="user_consent"]');
                    if(nextQuestion != 'step-result') {
                        if (navigationBtnEl == document.querySelector('.dynamicQuestion#step-1 .right-navigation-button-container')) {
                            // console.log("Inside first question next");
                            let input = document.querySelector('.question-answer#step-1-questionContainer [data-option-type="multiCheckboxes"] input[type="checkbox"]:checked');
                            if (input.value == 'Me') {
                                // console.log("Inside Me");
                                this.typeOfQuestion = 'WOB';
                            } else {
                                // console.log("Inside my child");
                                this.typeOfQuestion = 'QAC';
                                // this.QACIntroSlider.classList.remove('d-none');
                                // this.WOBQuizContainer.classList.add('d-none');
                            }
                            
                            if (consent && consent.checked) {
                                document.querySelector(`.dynamicQuestion#${nextQuestion}`).classList.remove('d-none');
                                currentQuestion.classList.add('d-none');

                                window.dataLayer.push({
                                    'event': 'wob_started_consent_yes'
                                });
                            }
                            else {
                                var wrapper = document.querySelector('.consent_checkbox_wrapper');
                                if (wrapper) {
                                    wrapper.classList.add('required');
                                    setTimeout(function () {
                                        wrapper.classList.remove('required');
                                    }, 2000);

                                    window.dataLayer.push({
                                        'event': 'wob_started_consent_no'
                                    });
                                }
                            }
                            
                        }
                        else if (navigationBtnEl == document.querySelector('.dynamicQuestion#step-3 .right-navigation-button-container')) {
                            // console.log("Inside third question next");
                            let input = document.querySelector('.question-answer#step-3-questionContainer input[type="checkbox"]:checked');
                            if (input.value == 'Yes') {
                                this.diagnosedQuestionsContainer.classList.remove('d-none');
                                document.querySelector(`#diagnosed-questions .dynamicQuestion#step-4`).classList.remove('d-none');
                                this.commonQuestionsContainer.classList.add('d-none');
                                
                                document.querySelectorAll('[data-wob-quiz] .description-container .pagination .step.onlyUndiagnosed').forEach(function (onlyUndiagnosedSteps) {
                                    onlyUndiagnosedSteps.classList.add('d-none');
                                });
                            }
                            else {
                                this.isDiagnosedOrNot = false;
                                this.unDiagnosedQuestionsContainer.classList.remove('d-none');
                                document.querySelector(`#unDiagnosed-questions .dynamicQuestion#step-4`).classList.remove('d-none');
                                this.commonQuestionsContainer.classList.add('d-none');

                                document.querySelectorAll('[data-wob-quiz] .description-container .pagination .step.onlyUndiagnosed').forEach(function (onlyUndiagnosedSteps) {
                                    onlyUndiagnosedSteps.classList.remove('d-none');
                                });
                            }
                        }
                        else {
                            // console.log("Inside other question next",nextQuestion);
                            let questionType = '#common-questions';
                            let stringNextQuestion = nextQuestion.split("-");
                            let numericNextQuestion = parseInt(stringNextQuestion[1]);
                            if(numericNextQuestion>3 && this.isDiagnosedOrNot) {
                                questionType = '#diagnosed-questions';
                            }
                            else if (numericNextQuestion>3 && !this.isDiagnosedOrNot) {
                                questionType = '#unDiagnosed-questions';
                            }

                            // vas score slider/checkbox pulsing logic start 
                            if (e.currentTarget.classList.contains("soft-disabled")) {
                                let stepContainer = e.currentTarget.closest('.dynamicQuestion');
                                let checkedBoxes = stepContainer.querySelectorAll('input[type="checkbox"]:checked').length;
                                let rangeInput = stepContainer.querySelector('input[type="range"]');
                                let rangeValue = rangeInput ? Number(rangeInput.value) : 0;
                                let optionsContainer = stepContainer.querySelector('.symptoms-option-container');
                                let scaleContainer = stepContainer.querySelector('.scale-container');
                                   
                                if (checkedBoxes > 0 && rangeValue === 0) {
                                    this.pulseElement(scaleContainer);
                                }
                                if (checkedBoxes === 0 && rangeValue > 0) {
                                    this.pulseElement(optionsContainer);
                                }
                                e.preventDefault();
                                return false;
                            }
                            // vas score slider/checkbox pulsing logic end

                            document.querySelector(`${questionType} .dynamicQuestion#${nextQuestion}`).classList.remove('d-none');
                            currentQuestion.classList.add('d-none');
                        }
                    }
                    else {
                        this.diagnosedQuestionsContainer.classList.add('d-none');
                        this.unDiagnosedQuestionsContainer.classList.add('d-none');
                        this.tyDivContainer.classList.remove('d-none');

                        setTimeout(() => {
                            this.tyDivContainer.classList.add('d-none');
                            this.quizContainer.classList.add('d-none');
                            this.resultContainer.classList.remove('d-none');
                        }, 2000);
                        
                        // this.sendAnswer();
                        // this.getBiggestIndicatorValue();
                        this.createSummaryHTMLSteps();
                        this.createSummaryHTML();

                        window.dataLayer.push({
                            'event': 'wob_completed'
                        });

                        this.signupForms.forEach(signupForm =>{
                            var webStageElement = document.createElement('input');
                            webStageElement.setAttribute('name', 'web_stage');
                            webStageElement.setAttribute('value', this.wob_stage);
                            webStageElement.setAttribute('readonly', '');
                            webStageElement.setAttribute('type', 'hidden');
                            signupForm.querySelector('.submitBtnContainer').before(webStageElement);
                        });
                    }

                    if(document.querySelector('.question-answer#step-1-questionContainer [data-option-type="multiCheckboxes"] input[type="checkbox"]:checked').value != '') {
                        if (consent && consent.checked) {
                            this.currentStep = nextQuestion;
                            let newString = nextQuestion.split("-");
                            this.currentQuestion = newString[1];
                            this.nextQuestion = parseInt(newString[1]) + 1;
                        }
                    }
                    
                    let stepElements = document.querySelectorAll('[data-wob-quiz] .description-container .pagination .step');
                    if (consent && consent.checked) {
                        for (let i = 0; i < stepElements.length; i++) {
                            stepElements[i].classList.remove('completed');
                            stepElements[i].classList.remove('active');
                            if (i <= [this.currentQuestion - 2]) {
                                stepElements[i].classList.add('completed');
                            }
                        }
                        if (nextQuestion != 'step-result') {
                            stepElements[this.currentQuestion - 1].classList.add('active');
                        }
                    }
                });
            });

            //to navigate to previous question for common question
            document.querySelectorAll('.dynamicQuestion .left-navigation-button-container').forEach(navigationBtnEl => {
                navigationBtnEl.addEventListener('click', () => {
                    // console.log("navigationBtnEl", navigationBtnEl);
                    let nextQuestion = navigationBtnEl.getAttribute('data-previous-step');
                    let currentQuestion = navigationBtnEl.closest('.dynamicQuestion');
                    let questionType = '#common-questions';
                    let stringNextQuestion = nextQuestion.split("-");
                    let numericNextQuestion = parseInt(stringNextQuestion[1]);
                    if(numericNextQuestion>2 && this.isDiagnosedOrNot) {
                        questionType = '#diagnosed-questions';
                    }
                    else if (numericNextQuestion>2 && !this.isDiagnosedOrNot) {
                        questionType = '#unDiagnosed-questions';
                    }
                    if (navigationBtnEl != document.querySelector(`${questionType} .dynamicQuestion#step-4 .left-navigation-button-container`)) {
                        // console.log("Inside if of not equal", navigationBtnEl.closest('.dynamicQuestion'));
                        document.querySelector(`${questionType} .dynamicQuestion#${nextQuestion}`).classList.remove('d-none');
                        currentQuestion.classList.add('d-none');
                    }
                    else {
                        // console.log("Inside else of being equal")
                        this.commonQuestionsContainer.classList.remove('d-none');
                        if(this.isDiagnosedOrNot) {
                            this.diagnosedQuestionsContainer.classList.add('d-none');
                        }
                        else {
                            this.unDiagnosedQuestionsContainer.classList.add('d-none');
                        }
                        currentQuestion.classList.add('d-none');
                        document.querySelector(`#common-questions .dynamicQuestion#${nextQuestion}`).classList.remove('d-none');
                    }
                    this.currentStep = nextQuestion;
                    let newString = nextQuestion.split("-");
                    this.currentQuestion = newString[1];
                    this.previousQuestion = parseInt(newString[1]) - 1;
                    let stepElements = document.querySelectorAll('[data-wob-quiz] .description-container .pagination .step');
                    for (let i = 0; i < stepElements.length; i++) {
                        stepElements[i].classList.remove('completed');
                        stepElements[i].classList.remove('active');
                        if (i <= [this.currentQuestion - 2]) {
                            stepElements[i].classList.add('completed');
                        }
                    }
                    if (nextQuestion != 'step-result') {
                        stepElements[this.currentQuestion - 1].classList.add('active');
                    }
                });
            });

            // consent box hide/show
            var radioInputs = document.querySelectorAll('#step-1-questionContainer input[name="common-0"]');
            var consentSection = document.querySelector('[data-consent-section]');
            var forChildTextSection = document.querySelector('.for-child-text');
            radioInputs.forEach(function (radio) {
                radio.addEventListener('change', function () {
                    var selected = document.querySelector('#step-1-questionContainer input[name="common-0"]:checked');
                    if (selected) {
                        if (consentSection) consentSection.classList.remove('d-none');
                        if (forChildTextSection) forChildTextSection.classList.add('d-none');
                    }
                    else {
                        if (consentSection) consentSection.classList.add('d-none');
                        if (forChildTextSection) forChildTextSection.classList.remove('d-none');
                    }

                    // if (selected && selected.value === 'My child') {
                    //     if (consentSection) consentSection.classList.add('d-none');
                    // } else {
                    //     if (consentSection) consentSection.classList.remove('d-none');
                    // }
                });
            });

            //if none option is selected
            document.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
                checkbox.addEventListener('change', (e) => {
                    let inputName = e.currentTarget.name;
                    // console.log("inputName", inputName);
                    if (inputName != null) {
                        let currentQuestionCheckboxes = document.querySelectorAll(`input[name="${inputName}"]`);
                        if (e.currentTarget.hasAttribute("data-none-option")) {
                            if (e.currentTarget.checked) {
                                currentQuestionCheckboxes.forEach(currentQuestionCheckbox => {
                                    if (!currentQuestionCheckbox.hasAttribute("data-none-option")) {
                                        currentQuestionCheckbox.checked = false
                                    }
                                });
                            }
                        }
                        else {
                            currentQuestionCheckboxes.forEach(currentQuestionCheckbox => {
                                if (currentQuestionCheckbox.hasAttribute("data-none-option")) {
                                    currentQuestionCheckbox.checked = false;
                                }
                            });
                        }
                    }
                });
            });

            //seasons option selection
            document.querySelectorAll('[data-question-collection="unDiagnosed"] .question-answer#step-8-questionContainer  input[type="checkbox"]').forEach(checkbox => {
                checkbox.addEventListener('change', () => {
                    if (checkbox.hasAttribute('data-attribute')) {

                        let dataAttributeValue = checkbox.getAttribute('data-attribute')
                        if (dataAttributeValue == "all season") {
                            document.querySelectorAll('[data-question-collection="unDiagnosed"] .question-answer#step-8-questionContainer input[type="checkbox"][data-attribute="season"]').forEach(otherCheckbox => {
                                otherCheckbox.checked = false;
                            })
                        }
                        else {
                            document.querySelector('[data-question-collection="unDiagnosed"] .question-answer#step-8-questionContainer input[type="checkbox"][data-attribute="all season"]').checked = false;
                        }
                    }
                });
            });

            // fad popup close
            document.querySelector('.result-fad-widget-popup .close-navigation-btn').addEventListener('click', (e) => {
                document.querySelector('.result-fad-widget-popup').classList.remove('active');
                document.querySelector('#steps-pagination .step.active').classList.remove('active');
            });

            //braze form submission
            this.signupForms.forEach(signupForm =>{
                console.log("for loop signupForm", signupForm)
                signupForm.querySelector('button').addEventListener('click', async (event) => {
                    event.preventDefault();
                    console.log("signupForm", signupForm);
                    let nameInput = signupForm.querySelector('input[name="first_name"]');
                    let emailInput = signupForm.querySelector('input[name="email"]');
                    const emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                    let verifiedEmail = emailInput.value.match(emailPattern);
                    let consentBox = signupForm.querySelector('input[data-consent-checkbox]');
                    let inputs = [emailInput];
                    let emailValue = emailInput.value;
                    inputs.forEach(input =>{
                        input.addEventListener('blur', () =>{
                            if(input.classList.contains('required') && input.value != null) {
                                input.classList.remove('required');
                            }
                        })
                    })
                    console.log("nameInput, emailInput, consentBox, consentBox.checked", nameInput,emailInput,consentBox, consentBox.checked )
                    if(verifiedEmail == null) {
                        emailInput.classList.add('required');
                    }
                    if(!consentBox.checked) {
                        let parent = consentBox.closest('.checkbox-label');
                        let checkMark = parent.querySelector('.custom-checkmark');
                        checkMark.classList.add('required');
                    }
                    if(verifiedEmail && consentBox.checked) {
                        let formData = new FormData(signupForm);
                        formData.append(
                            'existing_external_id',
                            md5(emailValue)
                        )
                        const response = await fetch("https://datahub.klarify.me/api/webhook/create_braze_profile", {
                            method: "POST",
                            body: formData,
                        });
                        const res = await response.json();
                        if (response.status == 200) {
                            if(res.data.attributes[0].external_id != '') {
                                if (typeof braze !== 'undefined') {
                                    //braze sdk is loaded and we can tun the changeUser function
                                    braze.changeUser(this.responseText);
                                }
                                if (typeof appboy !== 'undefined') {
                                    //braze legacy sdk(appboy) is loaded and we can tun the changeUser function
                                    appboy.changeUser(this.responseText);
                                }
                                if (this.getCookie('BUID_Cookie') == '' || this.getCookie('BUID_Cookie') == undefined) {
                                    this.setCookie('BUID_Cookie', res.data.attributes[0].external_id);
                                }
                                this.setCookie('WOBID_Cookie', res.data.attributes[0].external_id);
                                this.setCookie('WOB_email', emailValue);

                                let thankyouText = '';
                                if(this.knownUser){
                                    thankyouText = "Your report has been sent now. Thank you for doing the Allergy Review.";
                                }
                                else {
                                    let newsletterSignup = signupForm.querySelector('input[name="newsletter_signup"]');
                                    if(newsletterSignup.checked) {
                                        thankyouText = "You’ll shortly be getting a confirmation email. Please click on the link in the email so we know it’s really you. Then we’ll send the report.";
                                        document.querySelectorAll('.braze-form-container.result .resultMessage').forEach(resultMessage => {
                                            resultMessage.classList.remove('d-none');
                                        }); 
                                        this.newsletterSignupVal = 'on';
                                    }
                                    else {
                                        thankyouText = "Your report has been sent now. Thank you for doing the Allergy Review.";
                                        this.newsletterSignupVal = 'off';
                                    }
                                }
                                
                                let forms = document.querySelectorAll('.braze-form-container.form');
                                let formResults = document.querySelectorAll('.braze-form-container.result');

                                forms.forEach(form =>{
                                    form.classList.add('d-none');
                                });
                                formResults.forEach(formResult =>{
                                    formResult.querySelector('.description').innerHTML = thankyouText;
                                    formResult.classList.remove('d-none');
                                });
                                
                                document.querySelectorAll('.braze-form-container.form input[type="checkbox"]').forEach(formCheckboxes => {
                                    formCheckboxes.checked = false;
                                }); 
                                document.querySelectorAll('.braze-form-container.form input[type="text"], .braze-form-container.form input[type="email"]').forEach(formInputboxes => {
                                    formInputboxes.value = '';
                                });

                                let bodyData = {
                                    "response": this.answers,
                                    "email": emailValue,
                                    "external_id": res.data.attributes[0].external_id,
                                    "result_type": this.isDiagnosedOrNot ? 1 : 2,
                                    "language": 'en',
                                };
                                this.sendAnswer(bodyData);

                                if(document.querySelector('.braze-form-popup').classList.contains('d-none')){
                                    window.dataLayer.push({
                                        'event': 'wob_report_result_signup',
                                        'position': '1'
                                    });
                                }
                                else {
                                    window.dataLayer.push({
                                        'event': 'wob_report_result_signup',
                                        'position': '2'
                                    });
                                }
                            }
                        }
                    }
                });
            });
        },
        setHTML() {
            this.setCommonHTML();
            this.diagnosedQuestionsHTML();
            this.unDiagnosedQuestionsHTML();
        },
        
        pulseElement(el) {
            if (!el) return;
            el.classList.remove('pulse');
            void el.offsetWidth;
            el.classList.add('pulse');
            setTimeout(() => {
                el.classList.remove('pulse');
                void el.offsetWidth;
                el.classList.add('pulse');
                el.addEventListener('animationend', function handler() {
                    el.classList.remove('pulse');
                    el.removeEventListener('animationend', handler);
                });
            }, 300);
        },
        handleStep(stepId) {
            let stepContainer = document.querySelector(stepId);
            
            if (!stepContainer) return;
            let nextBtn = stepContainer.querySelector('.right-navigation-button-container');
            function updateButtonState(e) {
                let checkedBoxes = stepContainer.querySelectorAll('input[type="checkbox"]:checked').length;
                let rangeInput = stepContainer.querySelector('input[type="range"]');
                var rangeValue = Number(stepContainer.querySelector('input[type="range"]').value);
                if (e?.target?.type === 'checkbox' &&
                    !e.target.checked &&
                    checkedBoxes === 0 &&
                    rangeValue !== 0
                ) {
                    rangeInput.value = 0;
                    rangeValue = 0;
                    let characterImg = stepContainer.querySelector('.character img');
                    if (characterImg) {
                        characterImg.src = 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_blue_blob_test.svg';
                    }
                    rangeInput.dispatchEvent(new Event('input'));
                }
                let isValid = (checkedBoxes == 0 && rangeValue == 0) || (checkedBoxes > 0 && rangeValue > 0);
                // nextBtn.disabled = !isValid;
                nextBtn.classList.toggle('soft-disabled', !isValid);
                nextBtn.style.opacity = isValid ? '1' : '0.5';
            }
            //stepContainer.addEventListener('change', updateButtonState);
            stepContainer.addEventListener('input', updateButtonState);
        },

        setCommonHTML() {
            let questionsHTML = '';
            this.commonQuestions.forEach((question, questionIndex) => {
                let optionsHTML = '';
                question.multipleOptions.forEach((option) => {
                    let optionHTML = `
                    <label class="checkbox-item">
                        <input type="checkbox" name="common-${questionIndex}" value="${option.title}" ${option.disable == true ? 'data-none-option="true"' : ''}>
                        <span class="checkmark"></span>
                        ${option.title}
                    </label>
                        `;
                    optionsHTML += optionHTML;
                });

                let consentHtml = '';
                if(questionIndex == 0) {
                    consentHtml = `
                        <div class="for-child-text">
                            <p>If this is for your child, please answer the questions based on their symptoms and experience.</p>      
                        </div>
                        <div class="consent_checkbox_wrapper d-none" data-consent-section>
                            <div class="checkbox-container consent_checkbox">
                                <span class="consent-title">Consent*</span>
                                <label class="checkbox-label">
                                <input type="checkbox" class="custom-checkbox" name="user_consent" data-consent-checkbox="">
                                <span class="custom-checkmark"></span>
                                <span class="checkbox-text">I consent to klarify (ALK-Abelló A/S) processing the personal data I provide about Me, including any name provided and health data such as details of allergy symptoms. I understand that this processing is necessary for me to receive personalised content. I can withdraw my consent at any time. More information, including how to withdraw consent, is available in the <a href="/pages/privacy" target="_blank" class="target_blank semibold">Privacy policy</a>.</span>
                                </label>
                            </div>
                            <div class="required-field"><span class="medium">*Required</span></div>
                        </div>
                    `;
                }

                let questionHTML = `
                        <div class="dynamicQuestion ${questionIndex == 0 ? '' : 'd-none'}" id="step-${questionIndex + 1}" data-question-collection="common">
                            <div class="question-answer" id="step-${questionIndex + 1}-questionContainer">
                                <div class="question-answer-container"  data-options-type="multiCheckboxes" data-question-type="checkbox">
                                <h3 class="question col-8 col-sm-4 col-md-4 text-center mx-auto ${questionIndex == 0 ? 'd-none' : ''}">${question.question}</h3>
                                <div class="main-answer-container mx-auto">
                                    <div class="answer-container ${questionIndex == 0 ? 'd-none' : ''}" data-options>
                                        <div data-option-type="multiCheckboxes" class="d-md-flex">
                                            <div class="two-column checkboxes-container">
                                                <h4 class="select-applicable-title ${question.selectApplicable == true ? '' : 'd-none'}">Select all that apply</h4>
                                                ${optionsHTML}
                                            </div>
                                        </div>
                                    </div>
                                    ${consentHtml}
                                </div>
                                </div>
                            </div>
                            <div class="navigation-container d-flex">
                                <button class="align-items-center d-flex left-navigation-button-container ${questionIndex == 0 ? 'invisible' : ''}" data-previous-step="${questionIndex != 0 ? `step-${questionIndex}` : ''}">
                                    <span class="button-container left-button-container">
                                    <span class="icon-Group-3429-2 transform-180 arrow-glide-animation"></span>
                                    </span>
                                    <span class="button-label">BACK</span>
                                </button>
                                <button class="align-items-center d-flex right-navigation-button-container" disabled data-next-step="step-${questionIndex + 2}">
                                    <span class="button-label">NEXT</span>
                                    <span class="button-container right-button-container">
                                    <span class="icon-Group-3429-2 arrow-glide-animation"></span>
                                    </span>
                                </button>
                            </div>
                    </div>
                `;

                questionsHTML += questionHTML;
            });
            this.commonQuestionsContainer.innerHTML = questionsHTML;
        },
        diagnosedQuestionsHTML() {
            let questionsHTML = '';
            this.diagnosedQuestions.forEach((question, questionIndex) => {
                let trueQuestionIndex = questionIndex + 3;
                let questionHTML;
                let optionsHTML = '';
                if (question.questionType == 1) {
                    question.multipleOptions.forEach((option) => {
                        let optionHTML = `
                            <label class="checkbox-item">
                                <input type="checkbox" name="diagnosed-${trueQuestionIndex}" value="${option.title}" ${option.disable == true ? 'data-none-option="true"' : ''}>
                                <span class="checkmark"></span>
                                ${option.title}
                            </label>
                            `;
                        optionsHTML += optionHTML;
                    });
                    optionsHTML =  `<div class="two-column checkboxes-container">
                                        <h4 class="select-applicable-title ${question.selectApplicable == true ? '' : 'd-none'}">Select all that apply</h4>
                                        ${optionsHTML}
                                    </div>`;
                }
                if (question.questionType == 3) {
                    let optionHTML = ''
                    let subOptionsHTML = ''
                    question.subMultipleOptions.forEach((option) => {
                        let subOptionHTML = `
                        <label class="checkbox-item sub-options-checkbox-item">
                            <input type="checkbox" name="diagnosed-${trueQuestionIndex}" value="${option.title}" data-suboption="1" ${option.disable == true ? 'data-none-option="true"' : ''}>
                            <span class="checkmark"></span>
                            ${option.title}
                        </label>
                            `;
                        subOptionsHTML += subOptionHTML;
                    });
                    optionHTML = `<div class="subOptionsContainer">
                                    <div class="subOptionsHeader">${question.subMultipleOptionsCategory}:</div>
                                    ${subOptionsHTML}
                                </div>`;
                    optionsHTML = optionHTML;
                    question.multipleOptions.forEach((option) => {
                        let optionHTML = `
                            <label class="checkbox-item">
                                <input type="checkbox" name="diagnosed-${trueQuestionIndex}" value="${option.title}" ${option.disable == true ? 'data-none-option="true"' : ''}>
                                <span class="checkmark"></span>
                                ${option.title}
                            </label>
                            `;
                        optionsHTML += optionHTML;
                    });
                    optionsHTML =  `<div class="two-column checkboxes-container">
                                        <h4 class="select-applicable-title ${question.selectApplicable == true ? '' : 'd-none'}">Select all that apply</h4>
                                        ${optionsHTML}
                                    </div>`;
                }
                if (question.questionType == 4) {
                    let optionHTML = ''
                    let subOptionsHTML = ''
                    let secondSubOptionsHTML = ''
                    question.subMultipleOptions.forEach((option) => {
                        let subOptionHTML = `
                        <label class="checkbox-item">
                            <input type="checkbox" name="diagnosed-${trueQuestionIndex}" value="${option.title}" data-suboption="1" ${option.disable == true ? 'data-none-option="true"' : ''}>
                            <span class="checkmark"></span>
                            ${option.title}
                        </label>
                            `;
                        subOptionsHTML += subOptionHTML;
                    });
                    question.subMultipleOptions2.forEach((option) => {
                        let secondSubOptionHTML = `
                            <label class="checkbox-item">
                                <input type="checkbox" name="diagnosed-${trueQuestionIndex}" value="${option.title}" data-suboption="2" ${option.disable == true ? 'data-none-option="true"' : ''}>
                                <span class="checkmark"></span>
                                ${option.title}
                            </label>
                            `;
                        secondSubOptionsHTML += secondSubOptionHTML;
                    });
                    optionHTML = `<div class="second-suboptions-container col-md-8 pl-md-0 pr-md-4 pl-0 pr-0">
                                    <h4 class="select-applicable-title ${question.selectApplicable == true ? '' : 'd-none'}">Select all that apply</h4>
                                    <div class="second-suboptions-title">${question.subMultipleOptionsCategory}:</div>
                                    <div class="two-column">
                                        ${subOptionsHTML}
                                    </div>
                                </div>
                                <div class="first-suboptions-container">
                                    <div class="first-suboptions-title">${question.subMultipleOptionsCategory2}:</div>
                                    ${secondSubOptionsHTML}
                                </div>`;

                    optionsHTML += optionHTML;
                    optionsHTML =  `<div class="checkboxes-container d-md-flex">
                                                ${optionsHTML}
                                    </div>`;
                }

                //selecting whether indicator or checkbox slide
                if (question.questionType == 2) {
                    let indicatorOptions = ``;
                    question.multipleOptions.forEach((option) => {
                        let indicatorOption = `
                            <div class="symptoms-option">
                                <label>
                                    <input type="checkbox" name="diagnosed-${trueQuestionIndex}" value="${option.title}" ${option.disable == true ? 'data-none-option="true"' : ''}>
                                    <span>${option.title}</span>
                                </label>
                            </div>
                        `;
                        indicatorOptions += indicatorOption;
                    });

                    questionHTML = `
                        <div class="dynamicQuestion ${trueQuestionIndex == 3 ? '' : 'd-none'}" id="step-${trueQuestionIndex + 1}" data-question-collection="diagnosed">
                            <div class="question-answer" id="step-${trueQuestionIndex + 1}-questionContainer">
                                <div class="question-answer-container" data-options-type="indicatorOptions">
                                    <h3 class="question col-8 col-sm-4 col-md-4 text-center mx-auto">${question.question}</h3>
                                    <div class="answer-container" data-options>
                                        <div class="symptoms-container" data-option-type="indicatorOptions">
                                            <img class="symptoms-image" src="${question.logoImage}" alt="${question.category} logo" />
                                            <div class="symptoms-container-sub">
                                                <div class="symptoms-category">${question.category}</div>
                                                ${indicatorOptions.length > 0 ? `
                                                <div class="symptoms-heading">Select all that apply</div>
                                                <div class="symptoms-option-container d-flex">
                                                    ${indicatorOptions}
                                                </div>
                                                ` : ``}
                                            </div>
                                        </div>
                                        <div class="indicator-container">
                                            <div class="indicator-heading">How severely are you affected?</div>
                                            <div class="scale-container mx-auto">
                                                <div class="position-relative">
                                                    <input type="range" min="0" max="10" value="0" class="slider" id="${question.category}" />
                                                    <div class="number-labels"><span>0</span><span>1</span><span>2</span><span>3</span><span>4</span><span>5</span> <span>6</span><span>7</span><span>8</span><span>9</span><span>10</span></div>
                                                </div>
                                                <div class="labels">
                                                    <span class="sliderNotAffected indicatorText">NOT AFFECTED</span>
                                                    <div class="indicator-popup-text-container">Understand the scale</div>
                                                    <span class="sliderVeryAffected indicatorText">SEVERELY AFFECTED</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="navigation-container d-flex">
                                <button class="align-items-center d-flex left-navigation-button-container" data-previous-step="step-${trueQuestionIndex}">
                                    <span class="button-container left-button-container">
                                        <span class="icon-Group-3429-2 transform-180 arrow-glide-animation"></span>
                                    </span>
                                    <span class="button-label">BACK</span>
                                </button>
                                <button class="align-items-center d-flex right-navigation-button-container" ${trueQuestionIndex == 6 ? `data-next-step="step-result"` : `data-next-step="step-${trueQuestionIndex + 2}"`}>
                                    <span class="button-label">${trueQuestionIndex == 6 ? `SUBMIT` : `NEXT`}</span>
                                    <span class="button-container right-button-container">
                                        <span class="icon-Group-3429-2 arrow-glide-animation"></span>
                                    </span>
                                </button>
                            </div>
                        </div>
                    `;
                }
                else {
                    questionHTML = `
                        <div class="dynamicQuestion ${trueQuestionIndex == 3 ? '' : 'd-none'}" id="step-${trueQuestionIndex + 1}" data-question-collection="diagnosed">
                            <div class="question-answer" id="step-${trueQuestionIndex + 1}-questionContainer">
                                <div class="question-answer-container" data-question-type="checkbox" data-options-type="multiCheckboxes">
                                <h3 class="question col-8 col-sm-4 col-md-4 text-center mx-auto">${question.question}</h3>
                                <div class="main-answer-container mx-auto">
                                    <div class="answer-container" data-options>
                                        <div data-option-type="multiCheckboxes" class="d-md-flex">
                                            ${optionsHTML}
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div class="navigation-container d-flex">
                                <button class="align-items-center d-flex left-navigation-button-container" data-previous-step="step-${trueQuestionIndex}">
                                    <span class="button-container left-button-container">
                                    <span class="icon-Group-3429-2 transform-180 arrow-glide-animation"></span>
                                    </span>
                                    <span class="button-label">BACK</span>
                                </button>
                                <button class="align-items-center d-flex right-navigation-button-container" disabled ${trueQuestionIndex == 6 ? `data-next-step="step-result"` : `data-next-step="step-${trueQuestionIndex + 2}"`}>
                                    <span class="button-label">${trueQuestionIndex == 6 ? `SUBMIT` : `NEXT`}</span>
                                    <span class="button-container right-button-container">
                                    <span class="icon-Group-3429-2 arrow-glide-animation"></span>
                                    </span>
                                </button>
                            </div>
                        </div>
                    `;
                }


                questionsHTML += questionHTML;
            });
            this.diagnosedQuestionsContainer.innerHTML = questionsHTML;
            // this.handleStep('#step-5[data-question-collection="diagnosed"]');
            // this.handleStep('#step-6[data-question-collection="diagnosed"]');
        },
        unDiagnosedQuestionsHTML() {
            //adding name field to input of options and asking if suboptions walu logic
            //indicator popup walu text inline
            let questionsHTML = '';
            this.unDiagnosedQuestions.forEach((question, questionIndex) => {
                let trueQuestionIndex = questionIndex + 3;
                let questionHTML;
                let optionsHTML = '';
                if (question.questionType == 1) {
                    question.multipleOptions.forEach((option) => {
                        let optionHTML = `
                            <label class="checkbox-item">
                                <input type="checkbox" name="undiagnosed-${trueQuestionIndex}" value="${option.title}" ${option.disable == true ? 'data-none-option="true"' : ''} 
                                ${option.attribute != '' && option.attribute != undefined ? `data-attribute="${option.attribute}"` : ''}>
                                <span class="checkmark"></span>
                                ${option.title}
                            </label>
                            `;
                        optionsHTML += optionHTML;
                    });
                    optionsHTML =  `<div class="two-column checkboxes-container">
                                        <h4 class="select-applicable-title ${question.selectApplicable == true ? '' : 'd-none'}">Select all that apply</h4>
                                        ${optionsHTML}
                                    </div>`;
                }
                if (question.questionType == 3) {
                    let optionHTML = ''
                    let subOptionsHTML = ''
                    question.subMultipleOptions.forEach((option) => {
                        let subOptionHTML = `
                        <label class="checkbox-item sub-options-checkbox-item">
                            <input type="checkbox" name="undiagnosed-${trueQuestionIndex}" value="${option.title}" data-suboption="1" ${option.disable == true ? 'data-none-option="true"' : ''}>
                            <span class="checkmark"></span>
                            ${option.title}
                        </label>
                            `;
                        subOptionsHTML += subOptionHTML;
                    });
                    optionHTML = `<div class="subOptionsContainer">
                                    <div class="subOptionsHeader">${question.subMultipleOptionsCategory}:</div>
                                    ${subOptionsHTML}
                                </div>`;
                    optionsHTML = optionHTML;
                    question.multipleOptions.forEach((option) => {
                        let optionHTML = `
                            <label class="checkbox-item">
                                <input type="checkbox" name="undiagnosed-${trueQuestionIndex}" value="${option.title}" ${option.disable == true ? 'data-none-option="true"' : ''}>
                                <span class="checkmark"></span>
                                ${option.title}
                            </label>
                            `;
                        optionsHTML += optionHTML;
                    });
                    optionsHTML =  `<div class="two-column checkboxes-container">
                                        <h4 class="select-applicable-title ${question.selectApplicable == true ? '' : 'd-none'}">Select all that apply</h4>
                                        ${optionsHTML}
                                    </div>`;
                }
                if (question.questionType == 4) {
                    let optionHTML = ''
                    let subOptionsHTML = ''
                    let secondSubOptionsHTML = ''
                    question.subMultipleOptions.forEach((option) => {
                        let subOptionHTML = `
                        <label class="checkbox-item">
                            <input type="checkbox" name="undiagnosed-${trueQuestionIndex}" value="${option.title}" data-suboption="1" ${option.disable == true ? 'data-none-option="true"' : ''}>
                            <span class="checkmark"></span>
                            ${option.title}
                        </label>
                            `;
                        subOptionsHTML += subOptionHTML;
                    });
                    question.subMultipleOptions2.forEach((option) => {
                        let secondSubOptionHTML = `
                            <label class="checkbox-item">
                                <input type="checkbox" name="undiagnosed-${trueQuestionIndex}" value="${option.title}" data-suboption="2" ${option.disable == true ? 'data-none-option="true"' : ''}>
                                <span class="checkmark"></span>
                                ${option.title}
                            </label>
                            `;
                        secondSubOptionsHTML += secondSubOptionHTML;
                    });
                    optionHTML = `<div class="second-suboptions-container col-md-8">
                                    <h4 class="select-applicable-title ${question.selectApplicable == true ? '' : 'd-none'}">Select all that apply</h4>
                                    <div class="second-suboptions-title">${question.subMultipleOptionsCategory}:</div>
                                    <div class="two-column">
                                        ${subOptionsHTML}
                                    </div>
                                </div>
                                <div class="first-suboptions-container">
                                    <div class="first-suboptions-title">${question.subMultipleOptionsCategory2}:</div>
                                    ${secondSubOptionsHTML}
                                </div>`;

                    optionsHTML += optionHTML;
                    optionsHTML =  `<div class="checkboxes-container d-md-flex">
                                                ${optionsHTML}
                                    </div>`;
                }

                //selecting whether indicator or checkbox slide
                if (question.questionType == 2) {
                    let indicatorOptions = ``;
                    question.multipleOptions.forEach((option) => {
                        let indicatorOption = `
                            <div class="symptoms-option">
                                <label>
                                    <input type="checkbox" name="undiagnosed-${trueQuestionIndex}" value="${option.title}" ${option.disable == true ? 'data-none-option="true"' : ''} 
                                    ${option.attribute != '' && option.attribute != undefined ? `data-attribute="${option.attribute}"` : ''}>
                                    <span>${option.title}</span>
                                </label>
                            </div>
                        `;
                        indicatorOptions += indicatorOption;
                    });

                    questionHTML = `
                        <div class="dynamicQuestion ${trueQuestionIndex == 3 ? '' : 'd-none'}" id="step-${trueQuestionIndex + 1}" data-question-collection="unDiagnosed">
                            <div class="question-answer" id="step-${trueQuestionIndex + 1}-questionContainer">
                                <div class="question-answer-container" data-options-type="indicatorOptions">
                                    <h3 class="question col-8 col-sm-4 col-md-4 text-center mx-auto">${question.question}</h3>
                                    <div class="answer-container" data-options>
                                        <div class="symptoms-container" data-option-type="indicatorOptions">
                                            <img class="symptoms-image" src="${question.logoImage}" alt="${question.category} logo" />
                                            <div class="symptoms-container-sub">
                                                <div class="symptoms-category">${question.category}</div>
                                                ${indicatorOptions.length > 0 ? `
                                                <div class="symptoms-heading">Select all that apply</div>
                                                <div class="symptoms-option-container d-flex">
                                                    ${indicatorOptions}
                                                </div>
                                                ` : ``}
                                            </div>
                                        </div>
                                        <div class="indicator-container">
                                            <div class="indicator-heading">How severely are you affected?</div>
                                            <div class="scale-container mx-auto">
                                                <div class="position-relative">
                                                    <input type="range" min="0" max="10" value="0" class="slider" id="${question.category}" />
                                                    <div class="number-labels"><span>0</span><span>1</span><span>2</span><span>3</span><span>4</span><span>5</span> <span>6</span><span>7</span><span>8</span><span>9</span><span>10</span></div>
                                                </div>
                                                <div class="labels">
                                                    <span class="sliderNotAffected indicatorText">NOT AFFECTED</span>
                                                    <div class="indicator-popup-text-container">Understand the scale</div>
                                                    <span class="sliderVeryAffected indicatorText">SEVERELY AFFECTED</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="navigation-container d-flex">
                                <button class="align-items-center d-flex left-navigation-button-container" data-previous-step="step-${trueQuestionIndex}">
                                    <span class="button-container left-button-container">
                                        <span class="icon-Group-3429-2 transform-180 arrow-glide-animation"></span>
                                    </span>
                                    <span class="button-label">BACK</span>
                                </button>
                                <button class="align-items-center d-flex right-navigation-button-container" ${trueQuestionIndex == 9 ? `data-next-step="step-result"` : `data-next-step="step-${trueQuestionIndex + 2}"`}>
                                    <span class="button-label">${trueQuestionIndex == 9 ? `SUBMIT` : `NEXT`}</span>
                                    <span class="button-container right-button-container">
                                        <span class="icon-Group-3429-2 arrow-glide-animation"></span>
                                    </span>
                                </button>
                            </div>
                        </div>
                    `;
                }
                else {
                    questionHTML = `
                        <div class="dynamicQuestion ${trueQuestionIndex == 3 ? '' : 'd-none'}" id="step-${trueQuestionIndex + 1}" data-question-collection="unDiagnosed">
                            <div class="question-answer" id="step-${trueQuestionIndex + 1}-questionContainer">
                                <div class="question-answer-container" data-question-type="checkbox" data-options-type="multiCheckboxes">
                                <h3 class="question col-8 col-sm-4 col-md-4 text-center mx-auto">${question.question}</h3>
                                <div class="main-answer-container mx-auto">
                                    <div class="answer-container" data-options>
                                        <div data-option-type="multiCheckboxes" class="d-md-flex">
                                            ${optionsHTML}
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div class="navigation-container d-flex">
                                <button class="align-items-center d-flex left-navigation-button-container" data-previous-step="step-${trueQuestionIndex}">
                                    <span class="button-container left-button-container">
                                    <span class="icon-Group-3429-2 transform-180 arrow-glide-animation"></span>
                                    </span>
                                    <span class="button-label">BACK</span>
                                </button>
                                <button class="align-items-center d-flex right-navigation-button-container" disabled ${trueQuestionIndex == 9 ? `data-next-step="step-result"` : `data-next-step="step-${trueQuestionIndex + 2}"`}>
                                    <span class="button-label">${trueQuestionIndex == 9 ? `SUBMIT` : `NEXT`}</span>
                                    <span class="button-container right-button-container">
                                    <span class="icon-Group-3429-2 arrow-glide-animation"></span>
                                    </span>
                                </button>
                            </div>
                        </div>
                    `;
                }


                questionsHTML += questionHTML;
            });
            this.unDiagnosedQuestionsContainer.innerHTML = questionsHTML;
            this.handleStep('#step-4[data-question-collection="unDiagnosed"]');
            this.handleStep('#step-5[data-question-collection="unDiagnosed"]');
            this.handleStep('#step-6[data-question-collection="unDiagnosed"]');
        },
        getAnswer(e) {
            let isCommonQuestion = this.currentQuestion < 4;
            let dataOptionTypeElement, dataOptionType, question, category, subOptionQuestion, subOptionQuestion2, currentOptions = [], currentSubOptions = [], currentSubOptions2 = [];
            let currentQuestionIndex = this.currentQuestion - 1;
            let answerDL = {event: 'wob_question_answer', questionNumber: this.currentQuestion, answerValue: []};
            if(isCommonQuestion) {
                dataOptionTypeElement = document.querySelector(`#common-questions .question-answer#${this.currentStep}-questionContainer [data-options-type]`);
                question = this.commonQuestions[this.currentQuestion-1].question;
                category = this.commonQuestions[this.currentQuestion-1].category;
            }
            else {
                if(this.isDiagnosedOrNot) {
                    dataOptionTypeElement = document.querySelector(`#diagnosed-questions .question-answer#${this.currentStep}-questionContainer [data-options-type]`);
                    question = this.diagnosedQuestions[this.currentQuestion-4].question;
                    category = this.diagnosedQuestions[this.currentQuestion-4].category;
                    subOptionQuestion = this.diagnosedQuestions[this.currentQuestion-4].subMultipleOptionsCategory;
                    subOptionQuestion2 = this.diagnosedQuestions[this.currentQuestion-4].subMultipleOptionsCategory2;
                }
                else {
                    dataOptionTypeElement = document.querySelector(`#unDiagnosed-questions .question-answer#${this.currentStep}-questionContainer [data-options-type]`);
                    question = this.unDiagnosedQuestions[this.currentQuestion-4].question;
                    category = this.unDiagnosedQuestions[this.currentQuestion-4].category;
                    subOptionQuestion = this.unDiagnosedQuestions[this.currentQuestion-4].subMultipleOptionsCategory;
                    subOptionQuestion2 = this.unDiagnosedQuestions[this.currentQuestion-4].subMultipleOptionsCategory2;
                }
            }
            // currentOptions.splice(0, currentOptions.length);

            let optionObj = {};
            dataOptionType = dataOptionTypeElement.getAttribute('data-options-type');
            dataOptionTypeElement.querySelectorAll('input[type="checkbox"]:not([data-suboption]):not([name="user_consent"])').forEach(input => {
                if (input.checked == true) {
                    optionObj = {
                        title: `${input.value}`,
                        selected: true,
                    }
                    answerDL.answerValue.push(input.value);
                    currentOptions.push(optionObj)
                }
                else {
                    optionObj = {
                        title: `${input.value}`,
                        selected: false,
                    }
                    currentOptions.push(optionObj);
                }
            });
            this.answers[currentQuestionIndex].options = currentOptions;

            dataOptionTypeElement.querySelectorAll('input[type="checkbox"][data-suboption]').forEach(input => {
                let subOptionType = input.dataset.suboption;
                if(subOptionType == 1) {
                    if (input.checked == true) {
                        optionObj = {
                            title: `${input.value}`,
                            selected: true,
                        }
                        answerDL.answerValue.push(input.value);
                        currentSubOptions.push(optionObj)
                    }
                    else {
                        optionObj = {
                            title: `${input.value}`,
                            selected: false,
                        }
                        currentSubOptions.push(optionObj);
                    }
                }
                else {
                    if (input.checked == true) {
                        optionObj = {
                            title: `${input.value}`,
                            selected: true,
                        }
                        answerDL.answerValue.push(input.value);
                        currentSubOptions2.push(optionObj)
                    }
                    else {
                        optionObj = {
                            title: `${input.value}`,
                            selected: false,
                        }
                        currentSubOptions2.push(optionObj);
                    }
                }
            });
            this.answers[currentQuestionIndex].subOptions = currentSubOptions;
            this.answers[currentQuestionIndex].subOptions2 = currentSubOptions2;
            this.answers[currentQuestionIndex].subQuestion = subOptionQuestion;
            this.answers[currentQuestionIndex].subQuestion2 = subOptionQuestion2;

            if (dataOptionType == 'indicatorOptions') {
                this.answers[currentQuestionIndex].vas_score = dataOptionTypeElement.querySelector('input[type="range"]').value;
                answerDL.answerScrollValue = this.answers[currentQuestionIndex].vas_score;
            }
            
            this.answers[currentQuestionIndex].question = question;
            this.answers[currentQuestionIndex].category = category;
            console.log("this.answers", this.answers);

            let qacBtn = e.target.closest('.right-navigation-button-container').getAttribute('id');

            if(this.currentQuestion > 0 && document.querySelector('.soft-disabled') == null) {
                window.dataLayer.push(answerDL);
            }
        },
        createSummaryHTMLSteps() {
            //getting result title
            if(this.isDiagnosedOrNot == true) {
                // console.log("Inside diagnosed section of result title");
                let isConfidentManager = false;
                this.answers[4].options.forEach(option=>{
                    if(option.title == 'Yes' && option.selected == true) {
                        isConfidentManager = true;
                        this.resultTitle = 'The Confident Manager';
                    }
                });
                console.log("isConfidentManager", isConfidentManager)
                if(!isConfidentManager) {
                    this.answers[1].options.forEach(option=>{
                        if((option.title=="What allergy treatments are available" && option.selected == true) || 
                        (option.title=="How to prepare for a doctor's appointment" && option.selected == true) || 
                        (option.title=="How to manage allergies day to day" && option.selected == true)) {
                            console.log("The Proactive Navigator")
                            this.resultTitle = 'The Proactive Navigator';
                        }
                        else if((option.title=="Find out more about allergies in general" && option.selected == true) || 
                        (option.title=="Something else" && option.selected == true)) {
                            console.log("The Curious Investigator")
                            this.resultTitle = 'The Curious Investigator';
                        }
                        else if (option.title=="Whether my symptoms might be linked to an allergy" && option.selected == true) {
                            console.log("The Juggler")
                            this.resultTitle = 'The Juggler';
                        }
                    });
                }
            }
            else {
                console.log("Inside undiagnosed section of result title");
                this.answers[1].options.forEach(option=>{
                    if((option.title=="What allergy treatments are available" && option.selected == true) || 
                    (option.title=="How to prepare for a doctor's appointment" && option.selected == true) || 
                    (option.title=="How to manage allergies day to day" && option.selected == true)) {
                        this.resultTitle = 'The Proactive Navigator';
                    }
                    else if((option.title=="Find out more about allergies in general" && option.selected == true) || 
                    (option.title=="Something else" && option.selected == true)) {
                        this.resultTitle = 'The Curious Investigator';
                    }
                    else if (option.title=="Whether my symptoms might be linked to an allergy" && option.selected == true) {
                        this.resultTitle = 'The Juggler';
                    }
                })
            }
            console.log("this.resultTitle", this.resultTitle);

            //getting number of steps
            let actionPlanSetps = {};
            if(this.isDiagnosedOrNot == true) {
                console.log("Inside diagnosed section of number of steps");
                if(this.resultTitle == 'The Proactive Navigator') {
                    let shouldSkipD = false;
                    this.answers[1].options.forEach(option=>{
                        if (shouldSkipD) {
                            return false;
                        }
                        if(option.title=="How to manage allergies day to day" && option.selected == true) {
                            console.log("total 5 steps")//here add 5 steps html;
                            shouldSkipD = true;
                            document.querySelector('#steps-pagination').classList.add('total-steps-5');
                            actionPlanSetps = {
                                step1: {
                                    stepTitle: "Identify",
                                    stepSubtitle: "Track your symptoms",
                                    popupTitle: "Think it might be a pollen allergy?",
                                    popupText: "Track your symptoms daily in the klarify app for 3-4 weeks to spot possible hay fever triggers. Knowing your triggers is the first step to managing allergies. Every entry helps train the app to offer you more precise, personalised allergy insights.",
                                    popupLinktext: "Download the app",
                                    popupLinkUrl: "/pages/klarify-app",
                                    fadWidgetTrigger: false
                                },
                                step2: {
                                    stepTitle: "Understand",
                                    stepSubtitle: "Allergy treatments",
                                    popupTitle: "How to treat allergies",
                                    popupText: "Avoiding allergy triggers can help, but it isn’t always possible.  Some treatments relieve symptoms, while others target the underlying allergy.",
                                    popupLinktext: "Take a look at the different options.",
                                    popupLinkUrl: "/pages/allergy-treatment",
                                    fadWidgetTrigger: false
                                },
                                step3: {
                                    stepTitle: "Consider",
                                    stepSubtitle: "Talking to a doctor",
                                    popupTitle: "When should you see a doctor?",
                                    popupText: "If your symptoms become more difficult to manage or start affecting your day-to-day life, it may be worth talking to a doctor. They can assess what’s happening, discuss possible causes and advise whether allergy testing or treatment may be appropriate. ",
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: false
                                },
                                step4: {
                                    stepTitle: "How to",
                                    stepSubtitle: "Prepare for a doctor’s appointment",
                                    popupTitle: "Seeing a doctor about your symptoms?",
                                    popupText: "Make a note of your symptoms, when they happen and how they affect your day. Take a list of any allergy medicines you’ve tried. <br><br>Think about what you’d like to get from the appointment, such as finding out what might be triggering your symptoms and what you can do to help prevent them. Write down any questions you’d like to ask.",
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: false
                                },
                                step5: {
                                    stepTitle: "Reassess",
                                    stepSubtitle: "Check your symptoms over time",
                                    popupTitle: "Are your symptoms still under control?",
                                    popupText: "Even when your symptoms feel under control, recording them regularly in the klarify app can help you notice any changes. The app also shows local pollen levels and forecasts to help you plan your day during the pollen season. <br>If your symptoms become more difficult to manage or start affecting day-to-day life, it may be worth talking to a doctor.",
                                    popupLinktext: "Download the app",
                                    popupLinkUrl: "/pages/klarify-app",
                                    fadWidgetTrigger: false
                                },
                            }
                            this.wob_stage = 'pn_d_1';
                        }
                        if(option.title=="What allergy treatments are available" && option.selected == true) {
                            shouldSkipD = true;
                            console.log("total 4 steps")//here add 4 steps html;
                            document.querySelector('#steps-pagination').classList.add('total-steps-4');
                            actionPlanSetps = {
                                step1: {
                                    stepTitle: "Understand",
                                    stepSubtitle: "Allergy treatments",
                                    popupTitle: "How to treat allergies",
                                    popupText: "Avoiding allergy triggers can help, but it isn’t always possible.  Some treatments relieve symptoms, while others target the underlying allergy.",
                                    popupLinktext: "Take a look at the different options.",
                                    popupLinkUrl: "/pages/allergy-treatment",
                                    fadWidgetTrigger: false
                                },
                                step2: {
                                    stepTitle: "Consider",
                                    stepSubtitle: "Talking to a doctor",
                                    popupTitle: "When should you see a doctor?",
                                    popupText: "If your symptoms become more difficult to manage or start affecting your day-to-day life, it may be worth talking to a doctor. They can assess what’s happening, discuss possible causes and advise whether allergy testing or treatment may be appropriate. ",
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: false
                                },
                                step3: {
                                    stepTitle: "How to",
                                    stepSubtitle: "Prepare for a doctor’s appointment",
                                    popupTitle: "Seeing a doctor about your symptoms?",
                                    popupText: "Make a note of your symptoms, when they happen and how they affect your day. Take a list of any allergy medicines you’ve tried. <br><br>Think about what you’d like to get from the appointment, such as finding out what might be triggering your symptoms and what you can do to help prevent them. Write down any questions you’d like to ask.",
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: false
                                },
                                step4: {
                                    stepTitle: "Reassess",
                                    stepSubtitle: "Check your symptoms over time",
                                    popupTitle: "Are your symptoms still under control?",
                                    popupText: "Even when your symptoms feel under control, recording them regularly in the klarify app can help you notice any changes. The app also shows local pollen levels and forecasts to help you plan your day during the pollen season. <br>If your symptoms become more difficult to manage or start affecting day-to-day life, it may be worth talking to a doctor.",
                                    popupLinktext: "Download the app",
                                    popupLinkUrl: "/pages/klarify-app",
                                    fadWidgetTrigger: false
                                },
                            }
                            this.wob_stage = 'pn_d_2';
                        }
                        if(option.title=="How to prepare for a doctor's appointment" && option.selected == true) {
                            shouldSkipD = true;
                            console.log("total 3 steps")//here add 3 steps html;
                            document.querySelector('#steps-pagination').classList.add('total-steps-3');
                            actionPlanSetps = {
                                step1: {
                                    stepTitle: "Consider",
                                    stepSubtitle: "Talking to a doctor",
                                    popupTitle: "When should you see a doctor?",
                                    popupText: "If your symptoms become more difficult to manage or start affecting your day-to-day life, it may be worth talking to a doctor. They can assess what’s happening, discuss possible causes and advise whether allergy testing or treatment may be appropriate. ",
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: false
                                },
                                step2: {
                                    stepTitle: "How to",
                                    stepSubtitle: "Prepare for a doctor’s appointment",
                                    popupTitle: "Seeing a doctor about your symptoms?",
                                    popupText: "Make a note of your symptoms, when they happen and how they affect your day. Take a list of any allergy medicines you’ve tried. <br><br>Think about what you’d like to get from the appointment, such as finding out what might be triggering your symptoms and what you can do to help prevent them. Write down any questions you’d like to ask.",
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: false
                                },
                                step3: {
                                    stepTitle: "Reassess",
                                    stepSubtitle: "Check your symptoms over time",
                                    popupTitle: "Are your symptoms still under control?",
                                    popupText: "Even when your symptoms feel under control, recording them regularly in the klarify app can help you notice any changes. The app also shows local pollen levels and forecasts to help you plan your day during the pollen season. <br>If your symptoms become more difficult to manage or start affecting day-to-day life, it may be worth talking to a doctor.",
                                    popupLinktext: "Download the app",
                                    popupLinkUrl: "/pages/klarify-app",
                                    fadWidgetTrigger: false
                                },
                            }
                            this.wob_stage = 'pn_d_3';
                        }
                    })
                }
                if(this.resultTitle == 'The Confident Manager') {
                    console.log("total 1 steps")//here add 3 steps html;
                    document.querySelector('#steps-pagination').classList.add('total-steps-3');
                    actionPlanSetps = {
                        step1: {
                            stepTitle: "Reassess",
                            stepSubtitle: "Check your symptoms over time",
                            popupTitle: "Are your symptoms still under control?",
                            popupText: "Even when your symptoms feel under control, recording them regularly in the klarify app can help you notice any changes. The app also shows local pollen levels and forecasts to help you plan your day during the pollen season. <br>If your symptoms become more difficult to manage or start affecting day-to-day life, it may be worth talking to a doctor.",
                            popupLinktext: "Download the app",
                            popupLinkUrl: "/pages/klarify-app",
                            fadWidgetTrigger: false
                        },
                    }
                    this.wob_stage = 'cm';
                }
                if(this.resultTitle == 'The Curious Investigator') {
                    console.log("total 6 steps")//here add 6 steps html;
                    document.querySelector('#steps-pagination').classList.add('total-steps-6');
                    actionPlanSetps = {
                        step1: {
                            stepTitle: "Discover",
                            stepSubtitle: "Allergies explained",
                            popupTitle: "What are allergies?",
                            popupText: "Your immune system is there to protect you. But with an allergy, it overreacts to something that isn’t actually a threat<sup>1</sup>.",
                            popupLinktext: "See what can trigger allergies and which symptoms to look out for.",
                            popupLinkUrl: "/pages/what-are-allergies",
                            fadWidgetTrigger: false
                        },
                        step2: {
                            stepTitle: "Identify",
                            stepSubtitle: "Track your symptoms",
                            popupTitle: "Think it might be a pollen allergy?",
                            popupText: "Track your symptoms daily in the klarify app for 3-4 weeks to spot possible hay fever triggers. Knowing your triggers is the first step to managing allergies. Every entry helps train the app to offer you more precise, personalised allergy insights.",
                            popupLinktext: "Download the app",
                            popupLinkUrl: "/pages/klarify-app",
                            fadWidgetTrigger: false
                        },
                        step3: {
                            stepTitle: "Understand",
                            stepSubtitle: "Allergy treatments",
                            popupTitle: "How to treat allergies",
                            popupText: "Avoiding allergy triggers can help, but it isn’t always possible.  Some treatments relieve symptoms, while others target the underlying allergy.",
                            popupLinktext: "Take a look at the different options.",
                            popupLinkUrl: "/pages/allergy-treatment",
                            fadWidgetTrigger: false
                        },
                        step4: {
                            stepTitle: "Consider",
                            stepSubtitle: "Talking to a doctor",
                            popupTitle: "When should you see a doctor?",
                            popupText: "If your symptoms become more difficult to manage or start affecting your day-to-day life, it may be worth talking to a doctor. They can assess what’s happening, discuss possible causes and advise whether allergy testing or treatment may be appropriate. ",
                            popupLinktext: "",
                            popupLinkUrl: "",
                            fadWidgetTrigger: false
                        },
                        step5: {
                            stepTitle: "How to",
                            stepSubtitle: "Prepare for a doctor’s appointment",
                            popupTitle: "Seeing a doctor about your symptoms?",
                            popupText: "Make a note of your symptoms, when they happen and how they affect your day. Take a list of any allergy medicines you’ve tried. <br><br>Think about what you’d like to get from the appointment, such as finding out what might be triggering your symptoms and what you can do to help prevent them. Write down any questions you’d like to ask.",
                            popupLinktext: "",
                            popupLinkUrl: "",
                            fadWidgetTrigger: false
                        },
                        step6: {
                            stepTitle: "Reassess",
                            stepSubtitle: "Check your symptoms over time",
                            popupTitle: "Are your symptoms still under control?",
                            popupText: "Even when your symptoms feel under control, recording them regularly in the klarify app can help you notice any changes. The app also shows local pollen levels and forecasts to help you plan your day during the pollen season. <br>If your symptoms become more difficult to manage or start affecting day-to-day life, it may be worth talking to a doctor.",
                            popupLinktext: "Download the app",
                            popupLinkUrl: "/pages/klarify-app",
                            fadWidgetTrigger: false
                        },
                    }
                    this.wob_stage = 'ci_u';
                }
                if(this.resultTitle == 'The Juggler') {
                    console.log("total 5 steps")//here add 5 steps html;
                    document.querySelector('#steps-pagination').classList.add('total-steps-5');
                    actionPlanSetps = {
                        step1: {
                            stepTitle: "Identify",
                            stepSubtitle: "Track your symptoms",
                            popupTitle: "Think it might be a pollen allergy?",
                            popupText: "Track your symptoms daily in the klarify app for 3-4 weeks to spot possible hay fever triggers. Knowing your triggers is the first step to managing allergies. Every entry helps train the app to offer you more precise, personalised allergy insights.",
                            popupLinktext: "Download the app",
                            popupLinkUrl: "/pages/klarify-app",
                            fadWidgetTrigger: false
                        },
                        step2: {
                            stepTitle: "Understand",
                            stepSubtitle: "Allergy treatments",
                            popupTitle: "How to treat allergies",
                            popupText: "Avoiding allergy triggers can help, but it isn’t always possible.  Some treatments relieve symptoms, while others target the underlying allergy.",
                            popupLinktext: "Take a look at the different options.",
                            popupLinkUrl: "/pages/allergy-treatment",
                            fadWidgetTrigger: false
                        },
                        step3: {
                            stepTitle: "Consider",
                            stepSubtitle: "Talking to a doctor",
                            popupTitle: "When should you see a doctor?",
                            popupText: "If your symptoms become more difficult to manage or start affecting your day-to-day life, it may be worth talking to a doctor. They can assess what’s happening, discuss possible causes and advise whether allergy testing or treatment may be appropriate. ",
                            popupLinktext: "",
                            popupLinkUrl: "",
                            fadWidgetTrigger: false
                        },
                        step4: {
                            stepTitle: "How to",
                            stepSubtitle: "Prepare for a doctor’s appointment",
                            popupTitle: "Seeing a doctor about your symptoms?",
                            popupText: "Make a note of your symptoms, when they happen and how they affect your day. Take a list of any allergy medicines you’ve tried. <br><br>Think about what you’d like to get from the appointment, such as finding out what might be triggering your symptoms and what you can do to help prevent them. Write down any questions you’d like to ask.",
                            popupLinktext: "",
                            popupLinkUrl: "",
                            fadWidgetTrigger: false
                        },
                        step5: {
                            stepTitle: "Reassess",
                            stepSubtitle: "Check your symptoms over time",
                            popupTitle: "Are your symptoms still under control?",
                            popupText: "Even when your symptoms feel under control, recording them regularly in the klarify app can help you notice any changes. The app also shows local pollen levels and forecasts to help you plan your day during the pollen season. <br>If your symptoms become more difficult to manage or start affecting day-to-day life, it may be worth talking to a doctor.",
                            popupLinktext: "Download the app",
                            popupLinkUrl: "/pages/klarify-app",
                            fadWidgetTrigger: false
                        },
                    }
                    this.wob_stage = 'j_u';
                }
                
            }
            else {
                console.log("Inside undiagnosed section of number of steps");
                if(this.resultTitle == 'The Proactive Navigator') {
                    let shouldSkipUd = false;
                    this.answers[1].options.forEach(option=>{
                        if(option.title=="How to manage allergies day to day" && option.selected == true) {
                            console.log("total 5 steps")//here add 5 steps html;
                            shouldSkipUd = true;
                            document.querySelector('#steps-pagination').classList.add('total-steps-5');
                            actionPlanSetps = {
                                step1: {
                                    stepTitle: "Identify",
                                    stepSubtitle: "Track your symptoms",
                                    popupTitle: "Think it might be a pollen allergy? ",
                                    popupText: "Track your symptoms daily in the klarify app for 3-4 weeks to spot possible hay fever triggers. Knowing your triggers is the first step to managing allergies. Every entry helps train the app to offer you more precise, personalised allergy insights.",
                                    popupLinktext: "Download the app",
                                    popupLinkUrl: "/pages/klarify-app",
                                    fadWidgetTrigger: false
                                },
                                step2: {
                                    stepTitle: "Understand",
                                    stepSubtitle: "Allergy treatments",
                                    popupTitle: "How to treat allergies",
                                    popupText: " Avoiding allergy triggers can help, but it isn’t always possible.  Some treatments relieve symptoms, while others target the underlying allergy.",
                                    popupLinktext: "Take a look at the different options.",
                                    popupLinkUrl: "/pages/allergy-treatment",
                                    fadWidgetTrigger: false
                                },
                                step3: {
                                    stepTitle: "Consider",
                                    stepSubtitle: "Talking to a doctor",
                                    popupTitle: "When should you see a doctor?",
                                    popupText: "If your symptoms become more difficult to manage or start affecting your day-to-day life, it may be worth talking to a doctor. They can assess what’s happening, discuss possible causes and advise whether allergy testing or treatment may be appropriate. ",
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: false
                                },
                                step4: {
                                    stepTitle: "How to",
                                    stepSubtitle: "Prepare for a doctor’s appointment",
                                    popupTitle: "Seeing a doctor about your symptoms?",
                                    popupText: "Make a note of your symptoms, when they happen and how they affect your day. Take a list of any allergy medicines you’ve tried. <br><br>Think about what you’d like to get from the appointment, such as finding out what might be triggering your symptoms and what you can do to help prevent them. Write down any questions you’d like to ask.",
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: false
                                },
                                step5: {
                                    stepTitle: "Reassess",
                                    stepSubtitle: "Check your symptoms over time",
                                    popupTitle: "Are your symptoms still under control?",
                                    popupText: "Even when your symptoms feel under control, recording them regularly in the klarify app can help you notice any changes. The app also shows local pollen levels and forecasts to help you plan your day during the pollen season. <br>If your symptoms become more difficult to manage or start affecting day-to-day life, it may be worth talking to a doctor.",
                                    popupLinktext: "Download the app",
                                    popupLinkUrl: "/pages/klarify-app",
                                    fadWidgetTrigger: false
                                },
                            }
                            this.wob_stage = 'pn_u_1';
                        }
                        else if(option.title=="What allergy treatments are available" && option.selected == true) {
                            console.log("total 4 steps")//here add 4 steps html;
                            shouldSkipUd = true;
                            document.querySelector('#steps-pagination').classList.add('total-steps-4');
                            actionPlanSetps = {
                                step1: {
                                    stepTitle: "Understand",
                                    stepSubtitle: "Allergy treatments",
                                    popupTitle: "How to treat allergies",
                                    popupText: " Avoiding allergy triggers can help, but it isn’t always possible.  Some treatments relieve symptoms, while others target the underlying allergy.",
                                    popupLinktext: "Take a look at the different options.",
                                    popupLinkUrl: "/pages/allergy-treatment",
                                    fadWidgetTrigger: false
                                },
                                step2: {
                                    stepTitle: "Consider",
                                    stepSubtitle: "Talking to a doctor",
                                    popupTitle: "When should you see a doctor?",
                                    popupText: "If your symptoms become more difficult to manage or start affecting your day-to-day life, it may be worth talking to a doctor. They can assess what’s happening, discuss possible causes and advise whether allergy testing or treatment may be appropriate. ",
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: false
                                },
                                step3: {
                                    stepTitle: "How to",
                                    stepSubtitle: "Prepare for a doctor’s appointment",
                                    popupTitle: "Seeing a doctor about your symptoms?",
                                    popupText: "Make a note of your symptoms, when they happen and how they affect your day. Take a list of any allergy medicines you’ve tried. <br><br>Think about what you’d like to get from the appointment, such as finding out what might be triggering your symptoms and what you can do to help prevent them. Write down any questions you’d like to ask.",
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: false
                                },
                                step4: {
                                    stepTitle: "Reassess",
                                    stepSubtitle: "Check your symptoms over time",
                                    popupTitle: "Are your symptoms still under control?",
                                    popupText: "Even when your symptoms feel under control, recording them regularly in the klarify app can help you notice any changes. The app also shows local pollen levels and forecasts to help you plan your day during the pollen season. <br>If your symptoms become more difficult to manage or start affecting day-to-day life, it may be worth talking to a doctor.",
                                    popupLinktext: "Download the app",
                                    popupLinkUrl: "/pages/klarify-app",
                                    fadWidgetTrigger: false
                                },
                            }
                            this.wob_stage = 'pn_u_2';
                        }
                        else if(option.title=="How to prepare for a doctor's appointment" && option.selected == true) {
                            console.log("total 3 steps")//here add 3 steps html;
                            shouldSkipUd = true;
                            document.querySelector('#steps-pagination').classList.add('total-steps-3');
                            actionPlanSetps = {
                                step1: {
                                    stepTitle: "Consider",
                                    stepSubtitle: "Talking to a doctor",
                                    popupTitle: "When should you see a doctor?",
                                    popupText: "If your symptoms become more difficult to manage or start affecting your day-to-day life, it may be worth talking to a doctor. They can assess what’s happening, discuss possible causes and advise whether allergy testing or treatment may be appropriate. ",
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: false
                                },
                                step2: {
                                    stepTitle: "How to",
                                    stepSubtitle: "Prepare for a doctor’s appointment",
                                    popupTitle: "Seeing a doctor about your symptoms?",
                                    popupText: "Make a note of your symptoms, when they happen and how they affect your day. Take a list of any allergy medicines you’ve tried. <br><br>Think about what you’d like to get from the appointment, such as finding out what might be triggering your symptoms and what you can do to help prevent them. Write down any questions you’d like to ask.",
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: false
                                },
                                step3: {
                                    stepTitle: "Reassess",
                                    stepSubtitle: "Check your symptoms over time",
                                    popupTitle: "Are your symptoms still under control?",
                                    popupText: "Even when your symptoms feel under control, recording them regularly in the klarify app can help you notice any changes. The app also shows local pollen levels and forecasts to help you plan your day during the pollen season. <br>If your symptoms become more difficult to manage or start affecting day-to-day life, it may be worth talking to a doctor.",
                                    popupLinktext: "Download the app",
                                    popupLinkUrl: "/pages/klarify-app",
                                    fadWidgetTrigger: false
                                },
                            }
                            this.wob_stage = 'pn_u_3';
                        }
                    })
                }
                if(this.resultTitle == 'The Curious Investigator') {
                    console.log("total 7 steps")//here add 7 steps html;
                    document.querySelector('#steps-pagination').classList.add('total-steps-7');
                    actionPlanSetps = {
                        step1: {
                            stepTitle: "Discover",
                            stepSubtitle: "Allergies explained simply",
                            popupTitle: "What are allergies? ",
                            popupText: "Your immune system is there to protect you. But with an allergy, it overreacts to something that isn’t actually a threat<sup>1</sup>.",
                            popupLinktext: "See what can trigger allergies and which symptoms to look out for.",
                            popupLinkUrl: "/pages/what-are-allergies",
                            fadWidgetTrigger: false
                        },
                        step2: {
                            stepTitle: "Recognise",
                            stepSubtitle: "Cold or allergy?",
                            popupTitle: "Not sure if it’s a cold or an allergy?",
                            popupText: "It can be difficult to tell what’s causing your symptoms. But allergies often show different signs from a cold. Symptoms may start suddenly, and nasal mucus is often clear and watery<sup>2</sup>.",
                            popupLinktext: "See how to tell if an allergy or a cold might be causing your symptoms",
                            popupLinkUrl: "/pages/what-are-allergies",
                            fadWidgetTrigger: false
                        },
                        step3: {
                            stepTitle: "Identify",
                            stepSubtitle: "Track your symptoms",
                            popupTitle: "Think it might be a pollen allergy? ",
                            popupText: "Track your symptoms daily in the klarify app for 3-4 weeks to spot possible hay fever triggers. Knowing your triggers is the first step to managing allergies. Every entry helps train the app to offer you more precise, personalised allergy insights.",
                            popupLinktext: "Download the app",
                            popupLinkUrl: "/pages/klarify-app",
                            fadWidgetTrigger: false
                        },
                        step4: {
                            stepTitle: "Understand",
                            stepSubtitle: "Allergy treatments",
                            popupTitle: "How to treat allergies",
                            popupText: " Avoiding allergy triggers can help, but it isn’t always possible.  Some treatments relieve symptoms, while others target the underlying allergy.",
                            popupLinktext: "Take a look at the different options.",
                            popupLinkUrl: "/pages/allergy-treatment",
                            fadWidgetTrigger: false
                        },
                        step5: {
                            stepTitle: "Consider",
                            stepSubtitle: "Talking to a doctor",
                            popupTitle: "When should you see a doctor?",
                            popupText: "If your symptoms become more difficult to manage or start affecting your day-to-day life, it may be worth talking to a doctor. They can assess what’s happening, discuss possible causes and advise whether allergy testing or treatment may be appropriate. ",
                            popupLinktext: "",
                            popupLinkUrl: "",
                            fadWidgetTrigger: false
                        },
                        step6: {
                            stepTitle: "How to",
                            stepSubtitle: "Prepare for a doctor’s appointment",
                            popupTitle: "Seeing a doctor about your symptoms?",
                            popupText: "Make a note of your symptoms, when they happen and how they affect your day. Take a list of any allergy medicines you’ve tried. <br><br>Think about what you’d like to get from the appointment, such as finding out what might be triggering your symptoms and what you can do to help prevent them. Write down any questions you’d like to ask.",
                            popupLinktext: "",
                            popupLinkUrl: "",
                            fadWidgetTrigger: false
                        },
                        step7: {
                            stepTitle: "Reassess",
                            stepSubtitle: "Check your symptoms over time",
                            popupTitle: "Are your symptoms still under control?",
                            popupText: "Even when your symptoms feel under control, recording them regularly in the klarify app can help you notice any changes. The app also shows local pollen levels and forecasts to help you plan your day during the pollen season. <br>If your symptoms become more difficult to manage or start affecting day-to-day life, it may be worth talking to a doctor.",
                            popupLinktext: "Download the app",
                            popupLinkUrl: "/pages/klarify-app",
                            fadWidgetTrigger: false
                        },
                    }
                    this.wob_stage = 'ci_u';
                }
                if(this.resultTitle == 'The Juggler') {
                    console.log("total 6 steps")//here add 6 steps html;
                    document.querySelector('#steps-pagination').classList.add('total-steps-6');
                    actionPlanSetps = {
                        step1: {
                            stepTitle: "Recognise",
                            stepSubtitle: "Cold or allergy?",
                            popupTitle: "Not sure if it’s a cold or an allergy?",
                            popupText: "It can be difficult to tell what’s causing your symptoms. But allergies often show different signs from a cold. Symptoms may start suddenly, and nasal mucus is often clear and watery<sup>2</sup>.",
                            popupLinktext: "See how to tell if an allergy or a cold might be causing your symptoms",
                            popupLinkUrl: "/pages/what-are-allergies",
                            fadWidgetTrigger: false
                        },
                        step2: {
                            stepTitle: "Identify",
                            stepSubtitle: "Track your symptoms",
                            popupTitle: "Think it might be a pollen allergy? ",
                            popupText: "Track your symptoms daily in the klarify app for 3-4 weeks to spot possible hay fever triggers. Knowing your triggers is the first step to managing allergies. Every entry helps train the app to offer you more precise, personalised allergy insights.",
                            popupLinktext: "Download the app",
                            popupLinkUrl: "/pages/klarify-app",
                            fadWidgetTrigger: false
                        },
                        step3: {
                            stepTitle: "Understand",
                            stepSubtitle: "Allergy treatments",
                            popupTitle: "How to treat allergies",
                            popupText: " Avoiding allergy triggers can help, but it isn’t always possible.  Some treatments relieve symptoms, while others target the underlying allergy.",
                            popupLinktext: "Take a look at the different options.",
                            popupLinkUrl: "/pages/allergy-treatment",
                            fadWidgetTrigger: false
                        },
                        step4: {
                            stepTitle: "Consider",
                            stepSubtitle: "Talking to a doctor",
                            popupTitle: "When should you see a doctor?",
                            popupText: "If your symptoms become more difficult to manage or start affecting your day-to-day life, it may be worth talking to a doctor. They can assess what’s happening, discuss possible causes and advise whether allergy testing or treatment may be appropriate. ",
                            popupLinktext: "",
                            popupLinkUrl: "",
                            fadWidgetTrigger: false
                        },
                        step5: {
                            stepTitle: "How to",
                            stepSubtitle: "Prepare for a doctor’s appointment",
                            popupTitle: "Seeing a doctor about your symptoms?",
                            popupText: "Make a note of your symptoms, when they happen and how they affect your day. Take a list of any allergy medicines you’ve tried. <br><br>Think about what you’d like to get from the appointment, such as finding out what might be triggering your symptoms and what you can do to help prevent them. Write down any questions you’d like to ask.",
                            popupLinktext: "",
                            popupLinkUrl: "",
                            fadWidgetTrigger: false
                        },
                        step6: {
                            stepTitle: "Reassess",
                            stepSubtitle: "Check your symptoms over time",
                            popupTitle: "Are your symptoms still under control?",
                            popupText: "Even when your symptoms feel under control, recording them regularly in the klarify app can help you notice any changes. The app also shows local pollen levels and forecasts to help you plan your day during the pollen season. <br>If your symptoms become more difficult to manage or start affecting day-to-day life, it may be worth talking to a doctor.",
                            popupLinktext: "Download the app",
                            popupLinkUrl: "/pages/klarify-app",
                            fadWidgetTrigger: false
                        },
                    }
                    this.wob_stage = 'j_u';
                }
            }

            let StepsHTML = ``;
            if(Object.keys(actionPlanSetps).length > 0) {
                for (const [index, [key, value]] of Object.entries(Object.entries(actionPlanSetps))) {
                    console.log(index);
                    let stepNumber = parseInt(index) + 1;
                    // console.log(key);
                    // console.log(value);
                    // console.log(value.stepTitle);
                    let stepPopupContent = ``;
                    let stepPopupLink = ``;
                    if(value.popupLinkUrl != '') {
                        if((value.popupLinkUrl).indexOf('.pdf') >= 0) {
                            stepPopupLink = `<a href="${value.popupLinkUrl}" target="_blank"><u>${value.popupLinktext}</u> <i class="icon-arrow-next"></i></a>`;
                        }
                        else if(value.popupLinkUrl == '/pages/klarify-app') {
                           stepPopupLink = `
                                <div class="align-items-center d-flex app-icons">
                                    <a target="_blank" rel="nofollow" href="https://play.google.com/store/apps/details?id=me.klarify.klara&amp;hl=en_UK" class="mr-2">
                                        <img src="//uk.klarify.me/cdn/shop/files/google_play_badge_1024x1024_bf894abc-0bc1-44eb-b311-bd183a54841b_1024x1024.png?v=1613716540" alt="choose_google_play" class="active-btn">
                                    </a> 
                                    <a target="_blank" rel="nofollow" href="https://apps.apple.com/gb/app/klarify-pollen-app-hayfever/id1380057946">
                                        <img src="//uk.klarify.me/cdn/shop/files/Apple_Store_Badge.svg_a1192799-76fb-41fb-b22c-7970a691795d_1024x1024.png?v=1613716532" alt="choose_apple_play" class="active-btn">
                                    </a>
                                </div>
                           `; 
                        }
                        else {
                            stepPopupLink = `<a href="${value.popupLinkUrl}" class="result-close"><u>${value.popupLinktext}</u> <i class="icon-arrow-next"></i></a>`;
                        }
                    }
                    if(!value.fadWidgetTrigger) {
                        stepPopupContent = `
                            <div class="step-text-popup-overlay"></div>
                            <div class="step-text-popup">
                                <div class="close-navigation-btn">
                                    <span class="navigation-icon icon-Component-13--1"></span>
                                </div>
                                <span class="step-title">${value.stepSubtitle}</span>
                                <h4>${value.popupTitle}</h4>
                                <p>${value.popupText}</p>
                                ${stepPopupLink}
                            </div>`;
                    }
                    else {
                        document.querySelector('.web-on-boarding .wob-result-fad-widget .fad-widget-text-content p').innerHTML = value.popupText;
                    }
                    StepsHTML += `
                    <div class="step" data-step="${key}" data-fad-widget-trigger="${value.fadWidgetTrigger}">
                        <span class="step-number">${stepNumber}</span>
                        <div class="step-text"> 
                            <span class="step-title">${value.stepTitle}</span>
                            <span class="step-subtitle">${value.stepSubtitle}</span>
                        </div>
                        ${stepPopupContent}
                    </div>
                    `;
                }
            }
            document.querySelector('#steps-pagination').innerHTML = StepsHTML;

            if (window.innerWidth <= 767) {
                if(document.querySelector('[data-fad-widget-trigger="true"]')) {
                    let fadWidgetTriggerPoint = document.querySelector('[data-fad-widget-trigger="true"]');
                    let fadWidgetTriggerPosition = fadWidgetTriggerPoint.offsetTop;
                    let fadWidgetPopupPosition = fadWidgetTriggerPosition + 50;
                    document.querySelector('.web-on-boarding .result-fad-widget-popup .wob-result-fad-widget').style.top = fadWidgetPopupPosition +'px';
                }
            }

            // steps popup
            document.querySelectorAll('#steps-pagination .step-subtitle').forEach(stepTrrigger => {
                stepTrrigger.addEventListener('click', (e) => {
                    let currentStep = e.currentTarget.closest('.step');
                    currentStep.classList.add('active');
                    if(currentStep.getAttribute('data-fad-widget-trigger') == 'true') {
                        document.querySelector('.actionplan-steps .result-fad-widget-popup').classList.add('active');
                        window.dispatchEvent(new Event('resize'));
                    }
                });
            });
            document.querySelectorAll('#steps-pagination .close-navigation-btn').forEach(stepPopupClose => {
                stepPopupClose.addEventListener('click', (e) => {
                    let currentStep = e.currentTarget.closest('.step');
                    currentStep.classList.remove('active');
                });
            });

            //to scroll to braze
            console.log("Scroll function")
            document.querySelectorAll('.download-allergy-dashboard').forEach(dashboard =>{
                console.log("Inside the element", dashboard)
                dashboard.addEventListener('click', () => {
                    console.log("Inside dashboard click event", dashboard)
                    let parentStep = dashboard.closest('.step');
                    console.log("parentStep", parentStep, document.querySelector('#wob-braze-form-main'));
                    parentStep.classList.remove('active');
                    let offsetPosition = (document.querySelector('#wob-braze-form-main').offsetTop)-60;
                    console.log("offsetPosition", offsetPosition);
                    window.scroll(0, offsetPosition);
                    // document.querySelector('#wob-braze-form-main').scrollIntoView();
                });
            });

            document.querySelectorAll('.result-close').forEach(resultClose => {
                resultClose.addEventListener('click', (e)=>{
                    let dataUrl = e.target.getAttribute('href') != null ? e.target.getAttribute('href') : e.target.parentElement.getAttribute('href') != null ? e.target.parentElement.getAttribute('href') : '/pages/online-allergy-test';
                    this.closeQuizResultPopup.querySelector('.yes-btn').setAttribute("data-url", dataUrl);
                    this.closeQuizResultPopup.classList.remove('d-none');
                    
                    if(document.querySelector('.web-on-boarding .actionplan-steps .pagination .step.active')){
                        document.querySelector('.web-on-boarding .actionplan-steps .pagination .step.active').classList.remove('active');
                    }
                    if(document.querySelector('.web-on-boarding .result-fad-widget-popup.active')){
                        document.querySelector('.web-on-boarding .result-fad-widget-popup.active').classList.remove('active');
                    }
                    e.preventDefault();
                });
            });

            //getting message for result
            let selectedAllergies = 0;
            let selectedSubAllergies = 0;
            let otherAllergies = false;
            let totalSelectedAllergies = 0;
            let selectedAllergyVal = [];
            
            if(this.isDiagnosedOrNot == true) {
                // console.log("Inside diagnosed section of message");
                //calculate total selection and other selection
                this.answers[3].options.forEach(option=>{
                    if(option.selected) {
                        selectedAllergies++;
                        if(option.title == 'Other' || option.title == 'Other/I Don’t know' || option.title == 'I don’t know') {
                            otherAllergies = true;
                        }
                        selectedAllergyVal.push(option.title);
                    }
                })
                this.answers[3].subOptions.forEach(subOption =>{
                    if(subOption.selected) {
                        selectedSubAllergies++;
                        selectedAllergyVal.push(subOption.title);
                    }
                })
                totalSelectedAllergies = selectedSubAllergies + selectedAllergies;

                var formatter = new Intl.ListFormat('en-GB', { style: 'long', type: 'conjunction' });
                var selectedAllergyValString = formatter.format(selectedAllergyVal);

                // console.log("totalSelectedAllergies, otherAllergies", totalSelectedAllergies, otherAllergies);
                if(this.resultTitle == 'The Proactive Navigator') {
                    console.log("Inside Proactive Navigator");
                    if(otherAllergies) {
                        this.resultMessage = "Living with allergies can be challenging, but there are ways to help manage your symptoms. Here’s your allergy review.";
                    }
                    if(totalSelectedAllergies == 1 && otherAllergies == false) {
                        this.resultMessage = "Living with a "+ selectedAllergyVal[0] +" allergy can be challenging, but there are ways to help manage your symptoms. Here’s your allergy review.";
                    }
                    if(totalSelectedAllergies > 1 && otherAllergies == false) {
                        this.resultMessage = "Living with "+ selectedAllergyValString +" allergies can be challenging, but there are ways to help manage your symptoms. Here’s your allergy review.";
                    }
                }
                if(this.resultTitle == 'The Confident Manager') {
                    console.log("Inside Confident Manager");
                    if(otherAllergies) {
                        this.resultMessage = "You feel in control of your allergy, which is great. Here’s your allergy review to help you maintain control.";
                    }
                    if(totalSelectedAllergies == 1 && otherAllergies == false) {
                        this.resultMessage = "You feel in control of your "+ selectedAllergyVal[0] +" allergy, which is great. Here’s your allergy review to help you maintain control.";
                    }
                    if(totalSelectedAllergies > 1 && otherAllergies == false) {
                        this.resultMessage = "You feel in control of your "+ selectedAllergyValString +" allergies, which is great. Here’s your allergy review to help you maintain control.";
                    }
                }
                if(this.resultTitle == 'The Juggler') {
                    console.log("Inside Juggler");
                    if(otherAllergies) {
                        this.resultMessage = "You’ve been diagnosed with an allergy and want to better understand what that might mean for you. Here’s your allergy review.";
                    }
                    if(totalSelectedAllergies == 1 && otherAllergies == false) {
                        this.resultMessage = "You’ve been diagnosed with a "+ selectedAllergyVal[0] +" allergy and want to better understand what that might mean for you. Here’s your allergy review.";
                    }
                    if(totalSelectedAllergies > 1 && otherAllergies == false) {
                        this.resultMessage = "You’ve been diagnosed with "+ selectedAllergyValString +" allergies and want to better understand what that might mean for you. Here’s your allergy review.";
                    }
                }
                if(this.resultTitle == 'The Curious Investigator') {
                    console.log("Inside Curious Investigator");
                    if(otherAllergies) {
                        this.resultMessage = "You’ve been diagnosed with an allergy and would like to understand more about it. Here’s your allergy review.";
                    }
                    if(totalSelectedAllergies == 1 && otherAllergies == false) {
                        this.resultMessage = "You’ve been diagnosed with a "+ selectedAllergyVal[0] +" allergy and would like to understand it better. Here’s your allergy review.";
                    }
                    if(totalSelectedAllergies > 1 && otherAllergies == false) {
                        this.resultMessage = "You’ve been diagnosed with "+ selectedAllergyValString +" allergies and would like to understand them  better. Here’s your allergy review.";
                    }
                }
            }
            else {
                console.log("Inside undiagnosed section of message");
                this.answers[8].options.forEach(option=>{
                    if(option.selected) {
                        selectedAllergies++;
                        if(option.title == 'Other' || option.title == 'Other/I Don’t know' || option.title == 'I don’t know') {
                            otherAllergies = true;
                        }
                        selectedAllergyVal.push(option.title);
                    }
                })
                this.answers[8].subOptions.forEach(subOption =>{
                    if(subOption.selected) {
                        selectedSubAllergies++;
                        selectedAllergyVal.push(subOption.title);
                    }
                })
                totalSelectedAllergies = selectedSubAllergies + selectedAllergies;

                var formatter = new Intl.ListFormat('en-GB', { style: 'long', type: 'conjunction' });
                var selectedAllergyValString = formatter.format(selectedAllergyVal);

                // console.log("totalSelectedAllergies, otherAllergies", totalSelectedAllergies, otherAllergies);
                if(this.resultTitle == 'The Proactive Navigator') {
                    console.log("Inside Proactive Navigator");
                    if(otherAllergies) {
                        this.resultMessage = "You think your symptoms may be linked to an allergy and want to know more about managing allergies effectively. Here’s your allergy review.";
                    }
                    if(totalSelectedAllergies == 1 && otherAllergies == false) {
                        this.resultMessage = "You think your symptoms may be linked to a "+ selectedAllergyVal[0] +" allergy and want to know more about managing  allergies effectively. Here’s your allergy review.";
                    }
                    if(totalSelectedAllergies > 1 && otherAllergies == false) {
                        this.resultMessage = "You think your symptoms may be linked to "+ selectedAllergyValString +" allergies and want to know more about managing  allergies effectively. Here’s your allergy review.";
                    }
                }
                if(this.resultTitle == 'The Juggler') {
                    console.log("Inside Juggler");
                    if(otherAllergies) {
                        this.resultMessage = "You think your symptoms may be caused by an allergy. Here’s your allergy review.";
                    }
                    if(totalSelectedAllergies == 1 && otherAllergies == false) {
                        this.resultMessage = "You think your symptoms may be linked to a "+ selectedAllergyVal[0] +" allergy. Here’s your allergy review.";
                    }
                    if(totalSelectedAllergies > 1 && otherAllergies == false) {
                        this.resultMessage = "You think your symptoms may be linked to "+ selectedAllergyValString +" allergies. Here’s your allergy review.";
                    }
                }
                if(this.resultTitle == 'The Curious Investigator') {
                    console.log("Inside Curious Investigator");
                    if(otherAllergies) {
                        this.resultMessage = "You think you may be experiencing allergy symptoms and would like to understand allergies better. Here’s your allergy review.";
                    }
                    if(totalSelectedAllergies == 1 && otherAllergies == false) {
                        this.resultMessage = "You think a "+ selectedAllergyVal[0] +" allergy may be triggering your symptoms and would like to understand allergies better. Here’s your allergy review.";
                    }
                    if(totalSelectedAllergies > 1 && otherAllergies == false) {
                        this.resultMessage = "You think "+ selectedAllergyValString +" allergies may be triggering your symptoms and would like to understand allergies better. Here’s your allergy review.";
                    }
                }
            }
            // console.log("this.resultMessage", this.resultMessage);
            document.querySelector('#result-role').innerHTML = this.resultTitle;
            document.querySelector('#result-role-description').innerHTML = this.resultMessage;

            if(this.resultTitle == 'The Proactive Navigator') {
                document.querySelector('.role-logo').classList.add('proactive-navigator');
                document.querySelector('.role-logo img').setAttribute('src','https://cdn.shopify.com/s/files/1/0605/5156/1273/files/proactive-navigator.svg?v=1732255821');
            }
            if(this.resultTitle == 'The Confident Manager') {
                document.querySelector('.role-logo').classList.add('confident-manager');
                document.querySelector('.role-logo img').setAttribute('src','https://cdn.shopify.com/s/files/1/0605/5156/1273/files/confident-manager.svg?v=1732256312');
            }
            if(this.resultTitle == 'The Juggler') {
                document.querySelector('.role-logo').classList.add('juggler');
                document.querySelector('.role-logo img').setAttribute('src','https://cdn.shopify.com/s/files/1/0605/5156/1273/files/juggler.svg?v=1732255819');
            }
            if(this.resultTitle == 'The Curious Investigator') {
                document.querySelector('.role-logo').classList.add('curious-investigator');
                document.querySelector('.role-logo img').setAttribute('src','https://cdn.shopify.com/s/files/1/0605/5156/1273/files/curious-investigator.svg?v=1731393221');
            }

        },
        createSummaryHTML() {
            let resultHTML;
            var dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };
            var todayDate = new Date().toLocaleDateString('en-GB', dateOptions);
            resultHTML = `
                <div class="block-result-header">
                    <div class="date">${todayDate}</div>
                    <h3 class="doctor-heading" data-doctor-heading>My results summary</h3>
                </div>
                <div class="block-result-body">
                `;
            if(this.isDiagnosedOrNot == true) {
                let forWhomeHTML = ``;
                let forWhomeOptions = ``;
                this.answers[0].options.forEach(option => {
                    forWhomeOptions = forWhomeOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                                <input type="checkbox" name="diagnosis-confirm" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                                <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                                ${option.title}
                        </label>`;
                });
                forWhomeHTML = `
                    <div class="diagnosis-confirm block-result-container">
                        <div class="title-container">Allergy test for</div>
                        <div class="diagnosis-confirm-options block-result-options-div">
                            <div class="block-result-options">
                                ${forWhomeOptions}
                            </div>
                        </div>
                    </div>
                `;
                let diagnosisConfirmHTML = ``;
                let diagnosisConfirmOptions = ``;
                this.answers[2].options.forEach(option => {
                    diagnosisConfirmOptions = diagnosisConfirmOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                                <input type="checkbox" name="diagnosis-confirm" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                                <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                                ${option.title}
                        </label>`;
                });
                diagnosisConfirmHTML = `
                    <div class="diagnosis-confirm block-result-container">
                        <div class="title-container">Allergy diagnosis confirmed by a doctor</div>
                        <div class="diagnosis-confirm-options block-result-options-div">
                            <div class="block-result-options">
                                ${diagnosisConfirmOptions}
                            </div>
                        </div>
                    </div>
                `;

                let suspectedTriggersHTML = ``;
                let suspectedTriggersOptions = ``;
                let suspectedTriggersSubOptions = ``;
                let suspectedTriggersSubHeader = this.answers[3].subQuestion;
                this.answers[3].options.forEach(option => {
                    suspectedTriggersOptions = suspectedTriggersOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                            <input type="checkbox" name="suspected-trigger" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                            <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                            ${option.title}
                        </label>`;
                });
                this.answers[3].subOptions.forEach(subOption => {
                    suspectedTriggersSubOptions = suspectedTriggersSubOptions + `
                        <label class="checkbox-item ${subOption.selected == false ? 'inactive' : ''}">
                            <input type="checkbox" name="suspected-trigger" value="${subOption.title}" ${subOption.selected == true ? 'checked' : ''} disabled>
                            <span class="checkmark ${subOption.selected == false ? 'inactive' : ''}"></span>
                            ${subOption.title}
                        </label>`;
                });
                suspectedTriggersHTML = `
                    <div class="suspected-triggers block-result-container">
                        <div class="title-container">Diagnosed allergies</div>
                        <div class="suspected-triggers-options block-result-options-div">
                            <div class="block-result-options">
                                <div class="block-result-suboptions">
                                    <div class="block-result-subheading">${suspectedTriggersSubHeader}:</div>                                
                                    ${suspectedTriggersSubOptions}                        
                                </div>
                                ${suspectedTriggersOptions}
                            </div>
                        </div>
                    </div>
                `;

                let symptomOverviewHTML = ``;
                let indivualIndicatorContainerContent = ``;
                let options = ``;
                this.answers.forEach(answer => {
                    if (answer.category != '' && answer.category != undefined) {
                        let icon = ``;
                        if (answer.category == 'Eyes') {
                            icon = 'icon-DT_results_eye_icon_grey'
                        }
                        if (answer.category == 'Nose') {
                            icon = 'icon-DT_results_nose_icon_grey'
                        }
                        if (answer.category == 'Breathing') {
                            icon = 'icon-DT_results_breathing_icon_grey'
                        }
                        if (answer.category == 'Sleep') {
                            icon = 'icon-DT_results_tiredness_icon_grey'
                        }
                        options = answer.options.length > 0 ? '' : '<div class="option-text active">Tiredness or sleep disruptions</div>'
                        answer.options.forEach(option => {
                            options = options + `
                                <div class="option-text ${option.selected == true ? 'active' : ''}">${option.title}</div>
                            `;
                        })
                        let vasClass = '';
                        if (answer.vas_score == 0) {
                            vasClass = 'zero';
                        }
                        if (answer.vas_score == 1) {
                            vasClass = 'one';
                        }
                        if (answer.vas_score < 5 && answer.vas_score > 1) {
                            vasClass = 'two';
                        }
                        if (answer.vas_score > 4) {
                            vasClass = 'three';
                        }
                        indivualIndicatorContainerContent +=
                            `
                            <div class="indivual-indicator-container text-center">
                                <div><span class="d-inline ${icon} icons"></span></div>
                                <div class="options-text-container">${options}</div>
                                <button class="indicator-button ${vasClass}">${answer.vas_score}</button>
                            </div> 
                        `;
                    }
                });
                symptomOverviewHTML = `
                    <div class="symptom-overview block-result-container">
                        <div class="title-container">Symptom overview</div>                  
                        <div class="symptom-overview-options">                      
                            <div class="indicator-container">
                                <div class="d-flex flex-row flex-wrap">  
                                    ${indivualIndicatorContainerContent}
                                </div>                      
                                <div class="position-relative slider-container">
                                <input type="range" min="0" max="10" value="0" class="slider">
                                <div class="number-labels">
                                    <span>0</span><span>1</span><span>2</span><span>3</span><span>4</span><span>5</span>
                                    <span>6</span><span>7</span><span>8</span><span>9</span><span>10</span>
                                </div>
                                </div>                      
                                <div class="labels label-for-indicator">
                                    <span class="slider-not-affected indicator-text">NOT AFFECTED</span>
                                    <span class="slider-very-affected indicator-text">SEVERELY AFFECTED</span>
                                </div>
                                <div class="indicator-description">
                                    The VAS scale for allergic rhinitis (nasal symptoms) and allergic conjunctivitis (eye symptoms) is based on: Bousquet J, et al. Allergic Rhinitis and its Impact on Asthma (ARIA) 2008. Allergy 2008;63 Suppl 86:8-160.
                                </div>
                            </div>
                        </div>
                    </div>
                `;

                let breathingIssueHTML = ``;
                let breathingOptions = ``;
                this.answers[7].options.forEach(option => {
                    breathingOptions = breathingOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                                <input type="checkbox" name="breathing-issue" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                                <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                                ${option.title}
                        </label>`;
                });
                breathingIssueHTML = `
                    <div class="breathing-issues block-result-container">
                        <div class="title-container">Breathing issues</div>                  
                        <div class="breathing-issues-options block-result-options-div">                                              
                            <div class="block-result-options">                                              
                                ${breathingOptions}
                            </div>
                        </div>
                    </div>
                `;

                let symptomControlHTML = ``;
                let symptomControlOptions = ``;
                this.answers[4].options.forEach(option => {
                    symptomControlOptions = symptomControlOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                            <input type="checkbox" name="symptom-control" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                            <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                            ${option.title}
                        </label>`;
                });
                symptomControlHTML = `
                    <div class="symptom-control block-result-container">
                        <div class="title-container">Symptom control</div>
                        <div class="symptom-control-options block-result-options-div">
                        <div class="block-result-heading">IN CONTROL OF ALLERGY SYMPTOMS</div>
                            <div class="block-result-options">
                                ${symptomControlOptions}
                            </div>
                        </div>
                    </div>
                `;
                
                let diagnosedAllergiesHTML = ``;
                let managingAllergiesSubOptions = ``;
                this.answers[5].subOptions.forEach(option => {
                    managingAllergiesSubOptions = managingAllergiesSubOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                            <input type="checkbox" name="diagnosed-allergies" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                            <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                            ${option.title}
                        </label>`;
                });
                let managingAllergiesSubOptions2 = ``;
                this.answers[5].subOptions2.forEach(option => {
                    managingAllergiesSubOptions2 = managingAllergiesSubOptions2 + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                            <input type="checkbox" name="diagnosed-allergies" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                            <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                            ${option.title}
                        </label>`;
                });
                diagnosedAllergiesHTML = `
                    <div class="diagnosed-allergies block-result-container">
                        <div class="title-container">Allergy treatments I'm aware of</div>
                        <div class="diagnosed-allergies-options block-result-options-div">
                            <div class="block-result-heading">Short-term symptom relief </div>
                            <div class="block-result-options managing-allergies-suboptions">
                                ${managingAllergiesSubOptions}
                            </div>
                            <div class="block-result-heading">Allergy immunotherapy: </div>
                            <div class="block-result-options managing-allergies-suboptions2">
                                ${managingAllergiesSubOptions2}
                            </div>
                        </div>
                    </div>
                `;

                let allergiesAffectHTML = ``;
                let dailyLifeOptions = ``;
                this.answers[6].options.forEach(option => {
                    dailyLifeOptions = dailyLifeOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                            <input type="checkbox" name="allergies-affect" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                            <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                            ${option.title}
                        </label>`;
                });
                allergiesAffectHTML = `
                    <div class="allergies-affect block-result-container">
                        <div class="title-container">Impacted by allergies</div>
                        <div class="allergies-affect-options block-result-options-div">
                            <div class="block-result-options">
                                ${dailyLifeOptions}
                            </div>
                        </div>
                    </div>
                `;
                
                resultHTML += `
                    <div class="row diagnosed-result">
                        <div class="col-12 col-md-6 block-result-column-one">
                            ${forWhomeHTML}
                            ${suspectedTriggersHTML}
                            ${allergiesAffectHTML}
                            <!--${symptomOverviewHTML}
                            ${breathingIssueHTML}-->
                        </div>
                        <div class="col-12 col-md-6 block-result-column-two">
                            ${diagnosisConfirmHTML}
                            ${symptomControlHTML}
                            ${diagnosedAllergiesHTML}
                        </div>
                    </div>
                `;
            }
            else {
                let forWhomeHTML = ``;
                let forWhomeOptions = ``;
                this.answers[0].options.forEach(option => {
                    forWhomeOptions = forWhomeOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                                <input type="checkbox" name="diagnosis-confirm" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                                <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                                ${option.title}
                        </label>`;
                });
                forWhomeHTML = `
                    <div class="diagnosis-confirm block-result-container">
                        <div class="title-container">Allergy test for</div>
                        <div class="diagnosis-confirm-options block-result-options-div">
                            <div class="block-result-options">
                                ${forWhomeOptions}
                            </div>
                        </div>
                    </div>
                `;

                let diagnosisConfirmHTML = ``;
                let diagnosisConfirmOptions = ``;
                this.answers[2].options.forEach(option => {
                    diagnosisConfirmOptions = diagnosisConfirmOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                                <input type="checkbox" name="diagnosis-confirm" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                                <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                                ${option.title}
                        </label>`;
                });
                diagnosisConfirmHTML = `
                    <div class="diagnosis-confirm block-result-container">
                        <div class="title-container">Allergy diagnosis confirmed by a doctor</div>
                        <div class="diagnosis-confirm-options block-result-options-div">
                            <div class="block-result-options">
                                ${diagnosisConfirmOptions}
                            </div>
                        </div>
                    </div>
                `;

                let symptomOverviewHTML = ``;
                let indivualIndicatorContainerContent = ``;
                let options = ``;
                this.answers.forEach(answer => {
                    if (answer.category != '' && answer.category != undefined) {
                        let icon = ``;
                        if (answer.category == 'Eyes') {
                            icon = 'icon-DT_results_eye_icon_grey'
                        }
                        if (answer.category == 'Nose') {
                            icon = 'icon-DT_results_nose_icon_grey'
                        }
                        if (answer.category == 'Breathing') {
                            icon = 'icon-DT_results_breathing_icon_grey'
                        }
                        if (answer.category == 'Sleep') {
                            icon = 'icon-DT_results_tiredness_icon_grey'
                        }
                        options = answer.options.length > 0 ? '' : '<div class="option-text active">Tiredness or sleep disruptions</div>'
                        answer.options.forEach(option => {
                            options = options + `
                                <div class="option-text ${option.selected == true ? 'active' : ''}">${option.title}</div>
                            `;
                        })
                        let vasClass = '';
                        if (answer.vas_score == 0) {
                            vasClass = 'zero';
                        }
                        if (answer.vas_score == 1) {
                            vasClass = 'one';
                        }
                        if (answer.vas_score < 5 && answer.vas_score > 1) {
                            vasClass = 'two';
                        }
                        if (answer.vas_score > 4) {
                            vasClass = 'three';
                        }
                        indivualIndicatorContainerContent +=
                            `
                            <div class="indivual-indicator-container text-center">
                                <div><span class="d-inline ${icon} icons"></span></div>
                                <div class="options-text-container">${options}</div>
                                <button class="indicator-button ${vasClass}">${answer.vas_score}</button>
                            </div> 
                        `;
                    }
                });
                symptomOverviewHTML = `
                    <div class="symptom-overview block-result-container">
                        <div class="title-container">Symptom overview</div>                  
                        <div class="symptom-overview-options">                      
                            <div class="indicator-container">
                                <div class="d-flex flex-row flex-wrap">  
                                    ${indivualIndicatorContainerContent}
                                </div>                      
                                <div class="position-relative slider-container">
                                <input type="range" min="0" max="10" value="0" class="slider">
                                <div class="number-labels">
                                    <span>0</span><span>1</span><span>2</span><span>3</span><span>4</span><span>5</span>
                                    <span>6</span><span>7</span><span>8</span><span>9</span><span>10</span>
                                </div>
                                </div>                      
                                <div class="labels label-for-indicator">
                                    <span class="slider-not-affected indicator-text">NOT AFFECTED</span>
                                    <span class="slider-very-affected indicator-text">SEVERELY AFFECTED</span>
                                </div>
                                <div class="indicator-description">
                                    The VAS scale for allergic rhinitis (nasal symptoms) and allergic conjunctivitis (eye symptoms) is based on: Bousquet J, et al. Allergic Rhinitis and its Impact on Asthma (ARIA) 2008. Allergy 2008;63 Suppl 86:8-160.
                                </div>
                            </div>
                        </div>
                    </div>
                `;

                let breathingIssueHTML = ``;
                let breathingOptions = ``;
                this.answers[6].options.forEach(option => {
                    breathingOptions = breathingOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                                <input type="checkbox" name="breathing-issue" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                                <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                                ${option.title}
                        </label>`;
                });
                breathingIssueHTML = `
                    <div class="breathing-issues block-result-container">
                        <div class="title-container">Breathing issues</div>                  
                        <div class="breathing-issues-options block-result-options-div">                                              
                            <div class="block-result-options">                                              
                                ${breathingOptions}
                            </div>
                        </div>
                    </div>
                `;

                let symptomsSeasonHTML = ``;
                let symptomsSeasonOptions = ``;
                this.answers[7].options.forEach(option => {
                    symptomsSeasonOptions = symptomsSeasonOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                            <input type="checkbox" name="symptom-season" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                            <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                            ${option.title}
                        </label>`;
                });
                symptomsSeasonHTML = `
                    <div class="symptoms-season block-result-container">
                        <div class="title-container">When symptoms are worse</div>
                            <div class="symptoms-season-options block-result-options-div">
                            <div class="block-result-options">
                                ${symptomsSeasonOptions}
                            </div>
                        </div>
                    </div>
                `;

                let suspectedTriggersHTML = ``;
                let suspectedTriggersOptions = ``;
                let suspectedTriggersSubOptions = ``;
                let suspectedTriggersSubHeader = this.answers[8].subQuestion;
                this.answers[8].options.forEach(option => {
                    suspectedTriggersOptions = suspectedTriggersOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                            <input type="checkbox" name="suspected-trigger" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                            <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                            ${option.title}
                        </label>`;
                });
                this.answers[8].subOptions.forEach(subOption => {
                    suspectedTriggersSubOptions = suspectedTriggersSubOptions + `
                        <label class="checkbox-item ${subOption.selected == false ? 'inactive' : ''}">
                            <input type="checkbox" name="suspected-trigger" value="${subOption.title}" ${subOption.selected == true ? 'checked' : ''} disabled>
                            <span class="checkmark ${subOption.selected == false ? 'inactive' : ''}"></span>
                            ${subOption.title}
                        </label>`;
                });
                suspectedTriggersHTML = `
                    <div class="suspected-triggers block-result-container">
                        <div class="title-container">Suspected triggers</div>
                        <div class="suspected-triggers-options block-result-options-div">
                            <div class="block-result-options">
                                <div class="block-result-suboptions">
                                    <div class="block-result-subheading">${suspectedTriggersSubHeader}:</div>                                
                                    ${suspectedTriggersSubOptions}                        
                                </div>
                                ${suspectedTriggersOptions}
                            </div>
                        </div>
                    </div>
                `;

                let allergicConditionsHTML = ``;
                let allergicConditionsOptions = ``;
                this.answers[9].options.forEach(option => {
                    allergicConditionsOptions = allergicConditionsOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                            <input type="checkbox" name="allergic-conditions" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                            <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                            ${option.title}
                        </label>`;
                });
                allergicConditionsHTML = `
                    <div class="allergic-conditions block-result-container">
                        <div class="title-container">Allergic conditions in my family</div>
                        <div class="allergic-conditions-options block-result-options-div">
                            <div class="block-result-options">
                                ${allergicConditionsOptions}
                            </div>
                        </div>
                    </div>
                `;

                let diseaseHaveHTML = ``;
                let diseaseHaveOptions = ``;
                this.answers[10].options.forEach(option => {
                    diseaseHaveOptions = diseaseHaveOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                            <input type="checkbox" name="disease-have" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                            <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                            ${option.title}
                        </label>`;
                });
                diseaseHaveHTML = `
                    <div class="disease-have block-result-container">
                        <div class="title-container">I have or used to have</div>
                        <div class="disease-have-options block-result-options-div">
                            <div class="block-result-options block-result-3-options">
                            ${diseaseHaveOptions}
                            </div>
                        </div>
                    </div>
                `;
                
                resultHTML += `
                    <div class="row undiagnosed-result">
                        <div class="col-12 col-md-6 block-result-column-one">
                            ${forWhomeHTML}
                            ${symptomOverviewHTML}
                            <!-- ${breathingIssueHTML} -->
                        </div>
                        <div class="col-12 col-md-6 block-result-column-two">
                            ${diagnosisConfirmHTML}
                            ${symptomsSeasonHTML}
                            ${suspectedTriggersHTML}
                            ${allergicConditionsHTML}
                            <!-- ${diseaseHaveHTML} -->
                        </div>
                    </div>
                `;
            }
            resultHTML += `
                <div class="row d-block">
                    <div class="result-button-container">
                        <button class="d-flex mx-auto">
                            <span class="buttonText save-result">Save Result</span>
                            <span class="icon-Group-7501-1 buttonIcon"></span>
                        </button>
                    </div>
                </div>
            </div>`;
            document.querySelector('#blockResult').innerHTML = resultHTML;

            document.querySelector('.block-result .result-button-container button').addEventListener('click', ()=>{
                document.querySelector('.braze-form-popup.quiz-popup-overlay').classList.remove('d-none');

                window.dataLayer.push({
                    'event': 'wob_report_download'
                });
            });
        },
        async sendAnswer(bodyData) {
            try {
                const response = await fetch(`https://alk-app.klarify.me/api/web-onboarding`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${window.klarifyAppToken}`,
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(bodyData)
                });
                const res = await response.json();
               // console.log("================", res)
                if(response.status == 200) {
                    let pdfLink = res.link;
                    let externalId = (this?.getCookie?.('WOBID_Cookie')) || localStorage.getItem('WOBID_Cookie');
                    let externalEmail = (this?.getCookie?.('WOB_email')) || localStorage.getItem('WOB_email');

                    const CurrDate = new Date();
                    const polandTime = new Date(
                        CurrDate.toLocaleString("en-US", { timeZone: "Europe/Warsaw" })
                    );
                    const pad = (n) => n.toString().padStart(2, '0');
                    const year = polandTime.getFullYear();
                    const month = pad(polandTime.getMonth() + 1);
                    const day = pad(polandTime.getDate());
                    const hours = pad(polandTime.getHours());
                    const minutes = pad(polandTime.getMinutes());
                    const seconds = pad(polandTime.getSeconds());

                    // Get Poland's UTC offset in minutes
                    const offsetMinutes = -polandTime.getTimezoneOffset();
                    const offsetSign = offsetMinutes >= 0 ? "+" : "-";
                    const offsetHours = pad(Math.floor(Math.abs(offsetMinutes) / 60));
                    const offsetMins = pad(Math.abs(offsetMinutes) % 60);

                    // Format full date string
                    const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${offsetSign}${offsetHours}:${offsetMins}`;

                    let callEvents = [
                        {
                            "external_id": externalId,
                            "email": externalEmail,
                            "time": formattedDate,
                            "name": "wob_report_result_email"
                        }
                    ];
                    let bodyDataMap = {
                        "external_id": externalId,
                        "url": pdfLink,
                        "newsletter_signup": this.newsletterSignupVal,
                        "wob_stage": this.wob_stage,
                        "events": callEvents,
                    };
                    this.sendPDFtoBraze(bodyDataMap);      
                }
            } catch (e) {
                console.error('API call failed', e);
            }
        },
        async sendPDFtoBraze(bodyDataMap) {
            // console.log("Inside the densPdf to braze function", bodyDataMap);
            try {
                response = await fetch(`https://datahub-v2.klarify.me/api/general/pdf-url`, {
                        method: 'POST',
                        headers: {
                            'Authorization': `Bearer ${window.datahubAPIKey}`,
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(bodyDataMap)
                    })
                    if(response.status === 200){
                        await response.json();
                    }
            } catch (e) {
                console.error('API call failed', e);
            }
        },
        setCookie(name, value, minutes) {
            let date = new Date();
            date.setTime(date.getTime() + (minutes * 60 * 1000));
            let c_value = escape(value) + ((minutes == null) ? "" : "; expires=" + date.toUTCString() + "; path=/");
            document.cookie = name + "=" + c_value;

            return document.cookie;
        },
        getCookie(name) {
            const cookies = document.cookie.split(';');
            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i].trim();
                if (cookie.startsWith(name + '=')) {
                    return cookie.substring(name.length + 1);
                }
            }
            return null; // Cookie not found
        },
    };
    window.webOnBoarding.init();
}